import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import image from "../components/Image";
import informationService from "../services/system";
import AuthService from "../services/security/auth.service";
import constants from "../utils/constants";
import docsService from "../services/docs";

var fieldRecordload = {};
var field = {};
var group = {};
var arrayFieldsSource = [];
var arrayFieldsSourceGroup = [];

const styles = StyleSheet.create({
    page: {
        padding: 10,
        backgroundColor: "#fff",
        fontSize: 10,
        display: "flex",
        flexDirection: "column",
    },
    rowHeaderFooterMain: {
        flexDirection: "row",
    },
    colHeaderFooterMain: {
        justifyContent: "left",
        alignItems: "left",
        padding: 4,
        textAlign: "left",
    },
    row: {
        flexDirection: "row",
        border: "1px solid #000",
    },
    rowFunds: {
        flexDirection: "row",
    },
    colHeader3w50Funds: {
        border: "1px solid #000",
        justifyContent: "center",
        alignItems: "center",
        padding: 4,
        textAlign: "center",
    },
    colHeader4w50Funds: {
        justifyContent: "right",
        alignItems: "right",
        textAlign: "right",
    },
    colHeader3w50: {
        borderRight: "1px solid #000",
        justifyContent: "left",
        alignItems: "left",
        padding: 4,
        textAlign: "left",
    },
    colHeader4w50: {
        justifyContent: "left",
        alignItems: "left",
        textAlign: "left",
    },
    colHeader5w100: {
        borderRight: "1px solid #000",
        borderLeft: "1px solid #000",
        borderBottom: "1px solid #000",
        justifyContent: "left",
        alignItems: "left",
        padding: 4,
        textAlign: "left",
    },
    colHeader5w100Funds: {
        justifyContent: "left",
        alignItems: "left",
        //paddingTop: 4,
        textAlign: "left",
        borderLeft: "1px solid #000",
        borderRight: "1px solid #000",
        borderTop: "1px solid #000",
    },
    colHeader5w100Funds1: {
        justifyContent: "left",
        alignItems: "left",
        //paddingTop: 4,
        textAlign: "left",
        border: "1px solid #000",
    },
    colBody1w100: {
        /*justifyContent: "left",
        alignItems: "left",
        textAlign: "left",*/
    },
    w33: { width: "33%" },
    w50: { width: "50%" },
    w60: { width: "55%" },
    w66: { width: "66%" },
    w40: { width: "45%" },
    w100: { width: "100%" },
    sectionText: {
        fontSize: 9,
        color: "#333",
    },
    footerFixed: {
        position: "absolute",
        bottom: 10, // margen inferior del PDF
        left: 10,   // igual que el padding del page
        right: 10,
        fontSize: 9,
        padding: 0,
        backgroundColor: "#fff",
    },
});

const formatNumber = (num) => {
    const numberReplace = num.toString().replace('.', ',');
    const parts = numberReplace.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let decimals = '00';
    if (parts.length > 1) {
        decimals = parts[1];
    }
    return parts[0] + ',' + decimals;
};

const whereFunction = (itemField, field) => {

    let next = true;
    let validate;
    for (let i = 0; i < itemField.where.length; i++) {
        if (itemField.where[i].field !== null && itemField.where[i].field !== undefined) {
            for (let y = 0; y < itemField.where[i].field.length; y++) {
                if (next === true) {
                    //aca llega a obtener el ID del FIELD
                    let idField = itemField.where[i].field[y].idField;
                    switch (idField) {
                        case 'mode':
                            validate = false;
                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                                if (itemField.where[i].field[y].operator === 'in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if ('r' === idFlag) {
                                        validate = true;
                                    }
                                }
                                if (itemField.where[i].field[y].operator === 'not in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if ('r' === idFlag) {
                                        validate = false;
                                        break;
                                    } else {
                                        validate = true;
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }
                            break;
                        case 'role':
                            const user = AuthService.getCurrentUser();
                            validate = false;
                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                                if (itemField.where[i].field[y].operator === 'in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if (user.data.roleId === idFlag) {
                                        validate = true;
                                    }
                                }
                                if (itemField.where[i].field[y].operator === 'not in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if (user.data.roleId === idFlag) {
                                        validate = false;
                                        break;
                                    } else {
                                        validate = true;
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }
                            break;
                        default:
                            //aca llega a obtener el ID del FIELD
                            //Determino si el field con el ID obtenido tiene valor, sino tiene debe devolver false
                            //Si tiene valor, ingreso a validar el array de ID'S

                            //if (field[idField] || field[idField] === 0) {
                            validate = false;

                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {

                                if (itemField.where[i].field[y].operator === 'in') {
                                    if (typeof field[idField] === 'object') {
                                        if (field[idField]) {
                                            if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                                validate = true;
                                            }
                                        } else {
                                            if (field[idField] === itemField.where[i].field[y].id[d]) {
                                                validate = true;
                                            }
                                        }
                                    } else {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (itemField.where[i].field[y].id[d]) {
                                            idFlag = itemField.where[i].field[y].id[d].toString();
                                        }
                                        if (field[idField]) {
                                            if (field[idField].toString() === idFlag) {
                                                validate = true;
                                            }
                                        } else {
                                            if (field[idField] === (idFlag === "true" ? true : idFlag === "false" ? false : idFlag)) {
                                                validate = true;
                                            }
                                        }
                                    }
                                }

                                if (itemField.where[i].field[y].operator === 'not in') {
                                    if (typeof field[idField] === 'object') {

                                        if (field[idField]) {
                                            if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        }
                                        else {
                                            if (field[idField] === itemField.where[i].field[y].id[d]) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        }
                                    } else {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (itemField.where[i].field[y].id[d]) {
                                            idFlag = itemField.where[i].field[y].id[d].toString();
                                        }

                                        if (field[idField]) {
                                            if (field[idField].toString() === idFlag) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        } else {
                                            if (field[idField] === idFlag) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        }
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }

                            /*} else {
                                validate = false;
                            }*/
                            break;
                    }
                }
            }
        }
    }
    return validate;
}

const orderArray = array => {
    let temporal = 0;
    for (let i = 0; i < array.length; i++) {
        for (let j = 1; j < (array.length - i); j++) {
            if (array[j - 1].order > array[j].order) {
                temporal = array[j - 1];
                array[j - 1] = array[j];
                array[j] = temporal;
            }
        }
    }
    return array;
}

const filterByTradeAccountIdManagerId = (whereFieldParam) => {
    const user = AuthService.getCurrentUser();

    if (user.data.companyId) {
        let existe = false;
        whereFieldParam.forEach((item) => {
            if (item.idField === 'companyId') {
                existe = true;
                item.value = user.data.companyId
            }
        })
        if (existe === false) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        }
    }

    if (user.data.tradeAccountId) {
        let existe = false;
        whereFieldParam.forEach((item) => {
            if (item.idField === 'tradeAccountId') {
                existe = true;
                item.value = user.data.tradeAccountId
            }
        })
        if (existe === false) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: user.data.tradeAccountId
            })
        }
    } else {
        if (user.data.isManager === '1') {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'managerId') {
                    existe = true;
                    item.value = user.data.managerId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'managerId',
                    operator: '=',
                    value: user.data.managerId
                })
            }
        }
    }
}

const parseQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const operatorList = ['>=', '<=', '!=', 'like', '=', '>', '<']; // ordenado

    const result = [];

    for (const [key, value] of params.entries()) {
        if (key === 'm' || key === 'id') continue;

        let operator = '=';
        let field = key;
        let actualValue = value;

        for (const op of operatorList) {
            if (key.includes(op)) {
                const parts = key.split(op);
                field = parts[0];
                operator = op;

                if (operator === 'like' && !value) {
                    actualValue = parts[1] || '';
                }
                break;
            }
        }

        result.push({
            idField: field,
            operator: operator,
            value: actualValue
        });
    }
    return result;
}

const formatNumberWithThousandsSeparator = (num) => {
    const parts = num.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');

};

const initialDocHeader = (data, arrayResponse) => {

    data.crud.boxes.forEach((itemBoxs) => {
        itemBoxs.fields.forEach((itemFields) => {
            if (itemFields.defaultValue) {
                let idField = itemFields.id;
                switch (itemFields.type) {
                    case 'Select':
                        if (arrayResponse) {
                            arrayResponse.forEach((itemInfo) => {
                                if (itemInfo.source === itemFields.sourceSelect) {
                                    if (Number(itemFields.defaultValue) === Number(itemInfo.id)) {

                                        field[idField] = {
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        }

                                        fieldRecordload[idField] = {
                                            id: itemInfo.id,
                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        }

                                    }

                                }
                            })
                        }
                        break;
                    case 'Date':
                        if (itemFields.defaultValue === 'CURDATE()') {
                            field[idField] = new Date().toISOString().split('T')[0]
                            fieldRecordload[idField] = new Date().toISOString().split('T')[0]
                        }
                        if (itemFields.defaultValue === 'BOM()') {
                            const date = new Date();
                            date.setDate(1);
                            field[idField] = date.toISOString().split('T')[0]
                            fieldRecordload[idField] = date.toISOString().split('T')[0]
                        }
                        if (itemFields.defaultValue === 'BOY()') {
                            const date = new Date();
                            date.setMonth(0); // Enero
                            date.setDate(1);  // Día 1
                            field[idField] = date.toISOString().split('T')[0]
                            fieldRecordload[idField] = date.toISOString().split('T')[0]
                        }
                        if (itemFields.defaultValue === 'YESTERDAY()') {
                            const date = new Date();
                            date.setDate(date.getDate() - 1);
                            field[idField] = date.toISOString().split('T')[0]
                            fieldRecordload[idField] = date.toISOString().split('T')[0]
                        }
                        break;
                    case 'Switch':
                        if (itemFields.defaultValue === '0') {
                            field[idField] = false

                            fieldRecordload[idField] = false
                        }
                        if (itemFields.defaultValue === '1') {
                            field[idField] = true
                            fieldRecordload[idField] = true
                        }
                        break;
                    default:

                        field[idField] = itemFields.defaultValue

                        fieldRecordload[idField] = itemFields.defaultValue
                        break;
                }
            }

        })
    })

}

const initialDocGroup = (data, arrayResponse) => {

    for (let u = 0; u < data.crud.boxes.length; u++) {
        for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
            if (data.crud.boxes[u].fields[v].group !== null) {
                let objectsGroups = [];

                for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {
                    let objectGroup = {};
                    let arrayFields = [];
                    let nameGroup = data.crud.boxes[u].fields[v].group[b].name;
                    for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {

                        let itemFlag = JSON.parse(JSON.stringify(data.crud.boxes[u].fields[v].group[b].fields[m]));
                        let tamano = objectsGroups.length;
                        let newIdField = m + '_' + data.crud.boxes[u].fields[v].group[b].fields[m].id + '_' + m + tamano;
                        itemFlag.id = newIdField;
                        itemFlag.isGroup = true;

                        //buscar y reemplazar id de los where
                        if (itemFlag.where !== null) {
                            for (let r = 0; r < itemFlag.where.length; r++) {
                                if (itemFlag.where[r].field.length !== null) {
                                    for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                        let idField = itemFlag.where[r].field[d].idField;
                                        let existeIdGroup = false;

                                        for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                            if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                let tamano1 = objectsGroups.length;
                                                let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                existeIdGroup = true;
                                            }
                                        }

                                        if (existeIdGroup === false) {
                                            let newIdField1 = idField;
                                            itemFlag.where[r].field[d].idField = newIdField1;
                                        }
                                    }
                                }
                            }
                        }
                        //buscar y reemplazar id de los search source
                        if (itemFlag.searchSource !== null) {
                            for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                let idField = itemFlag.searchSource[r];
                                let existeIdGroup = false;
                                for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                    if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                        let tamano1 = objectsGroups.length;
                                        let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                        itemFlag.searchSource[r] = newIdField1;
                                        existeIdGroup = true;
                                    }
                                }

                                if (existeIdGroup === false) {
                                    let newIdField1 = idField;
                                    itemFlag.searchSource[r] = newIdField1;
                                }
                            }
                        }
                        arrayFields.push(itemFlag);

                        switch (itemFlag.type) {
                            case 'Select':

                                if (itemFlag.defaultValue) {
                                    if (arrayResponse) {
                                        let value = null;
                                        arrayResponse.forEach((itemInfo) => {
                                            if (itemInfo.source === itemFlag.sourceSelect) {
                                                if (Number(itemFlag.defaultValue) === Number(itemInfo.id)) {
                                                    value = {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    }
                                                }
                                            }
                                        })
                                        field[newIdField] = value;
                                        fieldRecordload[newIdField] = value
                                    }
                                } else {

                                    field[newIdField] = null;
                                    fieldRecordload[newIdField] = null;
                                }
                                break;
                            case 'MultipleSelect':
                                field[newIdField] = null;

                                fieldRecordload[newIdField] = null;
                                break;
                            case 'List':
                                field[newIdField] = null;

                                fieldRecordload[newIdField] = null;
                                break;
                            case 'Checkbox':
                                field[newIdField] = false;

                                fieldRecordload[newIdField] = false;
                                break;
                            case 'Switch':
                                field[newIdField] = false;

                                fieldRecordload[newIdField] = false;
                                break;
                            case 'Number':

                                field[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''

                                fieldRecordload[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                break;
                            case 'Currency':
                                field[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                fieldRecordload[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                break;
                            case 'Date':
                                if (itemFlag.defaultValue === 'CURDATE()') {
                                    field[newIdField] = new Date().toISOString().split('T')[0]
                                    fieldRecordload[newIdField] = new Date().toISOString().split('T')[0]
                                } else {
                                    if (itemFlag.defaultValue === 'BOM()') {
                                        const date = new Date();
                                        date.setDate(1);
                                        field[newIdField] = date.toISOString().split('T')[0]
                                        fieldRecordload[newIdField] = date.toISOString().split('T')[0]
                                    } else {
                                        if (itemFlag.defaultValue === 'BOY()') {
                                            const date = new Date();
                                            date.setMonth(0); // Enero
                                            date.setDate(1);  // Día 1
                                            field[newIdField] = date.toISOString().split('T')[0]
                                            fieldRecordload[newIdField] = date.toISOString().split('T')[0]
                                        } else {
                                            if (itemFlag.defaultValue === 'YESTARDAY()') {
                                                const date = new Date();
                                                date.setDate(date.getDate() - 1);
                                                field[newIdField] = date.toISOString().split('T')[0]
                                                fieldRecordload[newIdField] = date.toISOString().split('T')[0]
                                            } else {
                                                field[newIdField] = ''
                                                fieldRecordload[newIdField] = ''
                                            }
                                        }
                                    }
                                }
                                break;
                            default:

                                field[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                fieldRecordload[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                break;
                        }
                    }
                    objectGroup.fields = arrayFields;
                    objectsGroups.push(objectGroup);

                    group[nameGroup] = objectsGroups;

                }

            }
        }
    }
}

const searchFieldSource = async (item, changeValue, isTrxLine1, groupTrxLine1, data, mode, currencys, info) => {
    try {
        const user = AuthService.getCurrentUser();
        const instance = user.data.instance;
        let arrayFieldsSourceFlag = arrayFieldsSource.concat(arrayFieldsSourceGroup);

        if (groupTrxLine1) {
            let arraySourceFieldGroupFlag = [];
            for (let f = 0; f < groupTrxLine1.length; f++) {
                for (let a = 0; a < groupTrxLine1[f].fields.length; a++) {
                    if (groupTrxLine1[f].fields[a].searchSource !== null) {
                        let arraySearchSource = [];
                        let existe = false;
                        for (let q = 0; q < groupTrxLine1[f].fields[a].searchSource.length; q++) {

                            for (let o = 0; o < groupTrxLine1[f].fields.length; o++) {
                                if (groupTrxLine1[f].fields[a].searchSource[q] === groupTrxLine1[f].fields[o].id) {
                                    arraySearchSource.push(groupTrxLine1[f].fields[o]);
                                    existe = true;
                                }
                            }
                            if (existe === false) {
                                for (let g = 0; g < data.crud.boxes.length; g++) {
                                    for (let q1 = 0; q1 < data.crud.boxes[g].fields.length; q1++) {
                                        if (Number(groupTrxLine1[f].fields[a].searchSource[q]) === Number(data.crud.boxes[g].fields[q1].id)) {
                                            arraySearchSource.push(data.crud.boxes[g].fields[q1]);
                                        }
                                    }
                                }
                            }
                        }
                        arraySourceFieldGroupFlag.push({
                            id: groupTrxLine1[f].fields[a].id,
                            idFieldTable: groupTrxLine1[f].fields[a].idFieldTable,
                            type: groupTrxLine1[f].fields[a].type,
                            search: groupTrxLine1[f].fields[a].search,
                            searchSource: arraySearchSource,
                            sourceSelect: groupTrxLine1[f].fields[a].sourceSelect,
                            orderBox: 1,
                            nameGroup: 'trxLine1',
                            index: f
                        });
                    }
                }
            }
            arrayFieldsSourceFlag = arrayFieldsSource.concat(arraySourceFieldGroupFlag);
        }

        for (let h = 0; h < arrayFieldsSourceFlag.length; h++) {

            let existeSearchField = false;

            if (isTrxLine1 === true) {
                for (let p = 0; p < arrayFieldsSourceFlag[h].searchSource.length; p++) {
                    if (Number(arrayFieldsSourceFlag[h].searchSource[p].id.split('_')[1]) === Number(item.id.split('_')[1])) {
                        existeSearchField = true;
                    }
                }
            } else {
                for (let p = 0; p < arrayFieldsSourceFlag[h].searchSource.length; p++) {
                    //if (arrayFieldsSourceFlag[h].searchSource[p].id.includes(item.id)) {//REVISAR A PRIORI FUNCIONA 17/10/2025
                    if (arrayFieldsSourceFlag[h].searchSource[p].id === item.id) {//REVISAR A PRIORI FUNCIONA 17/10/2025
                        existeSearchField = true;
                    }
                    //modificacion 210725
                    if (arrayFieldsSourceFlag[h].searchSource[p].fieldsNoAdd === true) {
                        if (Number(arrayFieldsSourceFlag[h].searchSource[p].id) === Number(item.id.split('_')[1])) {
                            existeSearchField = true;
                        }
                    }
                    //modificacion 210725
                }
            }
            if (existeSearchField) {
                if (mode !== 'c' && mode !== 'u') {
                    if (field[arrayFieldsSourceFlag[h].id]) {
                        existeSearchField = false;
                    }
                }
                if (existeSearchField) {
                    let fieldsRequest = [];
                    let table = arrayFieldsSourceFlag[h].search;
                    let valueSearch = arrayFieldsSourceFlag[h].idFieldTable;
                    let idField = arrayFieldsSourceFlag[h].id;

                    let sourceSelect = arrayFieldsSourceFlag[h].sourceSelect;

                    if (arrayFieldsSourceFlag[h].type === 'Select') {
                        field[idField] = null;
                    } else {
                        field[idField] = '';
                    }

                    for (let p = 0; p < arrayFieldsSourceFlag[h].searchSource.length; p++) {

                        let idFieldTable = arrayFieldsSourceFlag[h].searchSource[p].idFieldTable;
                        let fieldFlag = idFieldTable.replace('Id', '');
                        if (fieldFlag === arrayFieldsSourceFlag[h].search) {
                            idFieldTable = 'id';
                        }
                        if (isTrxLine1 === true) {
                            fieldsRequest.push({
                                id: idFieldTable,
                                value: typeof changeValue === 'object' ? idFieldTable.toUpperCase().includes('ID') ? changeValue.id.replace(/\./g, '') : changeValue.id : idFieldTable.toUpperCase().includes('ID') ? changeValue.replace(/\./g, '') : changeValue
                            })
                        } else {
                            //modificacion 210725
                            let searchSourceId = arrayFieldsSourceFlag[h].searchSource[p].id;
                            if (arrayFieldsSourceFlag[h].searchSource[p].fieldsNoAdd === true) {
                                searchSourceId = item.id;
                            }
                            //modificacion 210725
                            if (item.id === searchSourceId) {
                                if (typeof changeValue === 'object') {
                                    if (changeValue)
                                        fieldsRequest.push({
                                            id: idFieldTable,
                                            value: idFieldTable.toUpperCase().includes('ID') ? changeValue.id.replace(/\./g, '') : changeValue.id
                                        })
                                } else {
                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: idFieldTable.toUpperCase().includes('ID') ? changeValue.replace(/\./g, '') : changeValue
                                    })
                                }
                            } else {

                                if (typeof field[searchSourceId] === 'object') {

                                    if (field[searchSourceId])
                                        fieldsRequest.push({
                                            id: idFieldTable,
                                            value: idFieldTable.toUpperCase().includes('ID') ? field[searchSourceId].id.replace(/\./g, '') : field[searchSourceId].id
                                        })
                                    else
                                        fieldsRequest.push({
                                            id: idFieldTable,
                                            value: null
                                        })
                                } else {
                                    let valueRequest = null;

                                    if (fieldRecordload[searchSourceId] !== null && fieldRecordload[searchSourceId] !== undefined)
                                        valueRequest = fieldRecordload[searchSourceId]

                                    if (valueRequest) {
                                        if (idFieldTable.toUpperCase().includes('ID')) {
                                            valueRequest = valueRequest.replace(/\./g, '');
                                        }
                                    }

                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: valueRequest
                                    })
                                }
                            }
                        }
                    }

                    let validateRequest = true;
                    for (let g = 0; g < fieldsRequest.length; g++) {
                        if (fieldsRequest[g].value === null)
                            validateRequest = false;
                    }

                    if (fieldsRequest.length > 0 && validateRequest) {

                        const response = await informationService.searchSource(table, instance, fieldsRequest);

                        if (response.data.length > 0) {
                            let newChangeValue = null;
                            if (arrayFieldsSourceFlag[h].type === 'Select') {

                                let idSearch;
                                let label;

                                if (response.data.length === 1) {

                                    idSearch = response.data[0][valueSearch];

                                    if (idSearch === undefined || idSearch === null) {
                                        idSearch = response.data[0].id;
                                    }

                                    if (info.length > 0) {

                                        for (const inf of info) {
                                            if (inf.source === sourceSelect) {
                                                if (Number(inf.id) === Number(idSearch)) {
                                                    label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                                }
                                            }
                                        }

                                        newChangeValue = {
                                            id: idSearch,
                                            label: label
                                        }

                                        if (label)
                                            field[idField] = newChangeValue

                                        //globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, newChangeValue, data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                    } else {

                                        let whereFilters = [];
                                        filterByTradeAccountIdManagerId(whereFilters);
                                        let arrayTables = [];
                                        arrayTables.push({
                                            table: `${user.data.instance}.${sourceSelect}`,
                                            doc: [],
                                            selectFilters: [],
                                            whereFilters: whereFilters
                                        })

                                        const response = await informationService.findSourceField(arrayTables);
                                        const res = response.data;
                                        for (const inf of res) {
                                            if (inf.source === sourceSelect) {
                                                if (Number(inf.id) === Number(idSearch)) {
                                                    label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                                }
                                            }
                                        }
                                        newChangeValue = {
                                            id: idSearch,
                                            label: label
                                        }

                                        if (label)
                                            field[idField] = newChangeValue
                                        //globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, newChangeValue, data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);

                                    }
                                }
                            } else {
                                if (arrayFieldsSourceFlag[h].type === 'Currency' || arrayFieldsSourceFlag[h].type.includes('Number')) {
                                    let valueFlag = response.data[0][valueSearch];
                                    if (valueFlag) {
                                        valueFlag = valueFlag.replace(/\./g, ',');
                                        if (mode === 'r')
                                            valueFlag = formatNumberWithThousandsSeparator(valueFlag);
                                    }

                                    if (arrayFieldsSourceFlag[h].type === 'Currency') {
                                        let step = 2;
                                        let fielFlag = field;
                                        data.crud.boxes.forEach((itemBoxes) => {
                                            itemBoxes.fields.forEach((itemFields) => {
                                                if (itemFields.idFieldTable === 'currencyId') {
                                                    let idfield1 = itemFields.id;
                                                    let valueComparate = fielFlag[idfield1];
                                                    if (valueComparate) {
                                                        for (let g = 0; g < currencys.length; g++) {
                                                            if (Number(currencys[g].id) === Number(valueComparate.id)) {
                                                                /*setFormatCurrency(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: currencys[g].symbol,
                                                                }), []);*/
                                                                step = currencys[g].decimals;
                                                            }
                                                        }
                                                    } /*else {
                                                        setFormatCurrency(prevState => ({
                                                            ...prevState,
                                                            [idField]: '',
                                                        }), []);
                                                    }*/
                                                }
                                            })
                                        })
                                        let value = valueFlag.split(',');

                                        field[idField] = `${value[0]},${value[1].slice(0, step)}`
                                        newChangeValue = `${value[0]},${value[1].slice(0, step)}`;
                                    } else {
                                        field[idField] = valueFlag
                                        newChangeValue = valueFlag;
                                    }
                                    //globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, valueFlag, data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                } else {
                                    field[idField] = response.data[0][valueSearch]

                                    newChangeValue = response.data[0][valueSearch];
                                    //globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, response.data[0][valueSearch], data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                }
                            }
                            //modificacion 230825
                            fieldRecordload[idField] = newChangeValue;
                            searchFieldSource({ id: idField }, newChangeValue, isTrxLine1, groupTrxLine1, data, 'r', currencys, null);

                            //modificacion 230825


                        } else {
                            if (arrayFieldsSourceFlag[h].type === 'Currency' || arrayFieldsSourceFlag[h].type.includes('Number'))
                                field[idField] = 0
                            if (arrayFieldsSourceFlag[h].type === 'Select')
                                field[idField] = {
                                    id: '',
                                    label: ''
                                }
                            if (arrayFieldsSourceFlag[h].type === 'TextField')
                                field[idField] = ''
                        }

                    }
                }
            }
        }

    } catch (error) {
        console.log('error searchFieldSource-> ' + JSON.stringify(error))
    }

}

const loadRecordPrint = async (idRecord, idDoc, currencys) => {
    fieldRecordload = {};
    field = {};
    group = {};
    arrayFieldsSource = [];
    arrayFieldsSourceGroup = [];
    const user = AuthService.getCurrentUser();
    if (user) {
        const response = await docsService.viewDocsFindAll(constants.CLIENT, user.data.instance);
        const dataResponse = response.data;

        let data = null;
        for (let d = 0; d < dataResponse.length; d++) {
            if (dataResponse[d].id === idDoc) {
                data = dataResponse[d];
                break;
            }
        }
        if (data !== null) {
            if (data.crud.boxes) {
                data.crud.boxes = orderArray(data.crud.boxes);
            }
            for (let h = 0; h < data.crud.boxes.length; h++) {
                for (let t = 0; t < data.crud.boxes[h].fields.length; t++) {
                    data.crud.boxes[h].fields = orderArray(data.crud.boxes[h].fields);
                }
            }
            if (data.crud.buttonsHeader) {
                data.crud.buttonsHeader = orderArray(data.crud.buttonsHeader);
            }
            if (data.crud.buttonsFooter) {
                data.crud.buttonsFooter = orderArray(data.crud.buttonsFooter);
            }
            if (data.crud.store) {
                data.crud.store = orderArray(data.crud.store);
            }

            let whereFilters = [];
            filterByTradeAccountIdManagerId(whereFilters);

            let arrayTables = [];
            for (let h = 0; h < data.crud.boxes.length; h++) {
                for (let u = 0; u < data.crud.boxes[h].fields.length; u++) {

                    if (data.crud.boxes[h].fields[u].sourceSelect !== null) {
                        let existe = false;
                        for (let y = 0; y < arrayTables.length; y++) {
                            if (data.crud.boxes[h].fields[u].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                existe = true;
                                if (data.crud.boxes[h].fields[u].dataSource.length > 0) {
                                    let existeSelectFilter = false;
                                    for (let y1 = 0; y1 < arrayTables[y].selectFilters.length; y1++) {
                                        if (arrayTables[y].selectFilters[y1] === data.crud.boxes[h].fields[u].idFieldTable) {
                                            existeSelectFilter = true;
                                        }
                                    }
                                    if (!existeSelectFilter) {
                                        if (data.crud.boxes[h].fields[u].idFieldTable && arrayTables[y].table.split('.')[1] !== data.crud.boxes[h].fields[u].idFieldTable.replace('Id', ''))
                                            arrayTables[y].selectFilters.push(data.crud.boxes[h].fields[u].idFieldTable);
                                    }
                                }
                            }
                        }

                        if (existe === false) {
                            let doc = [];
                            if (data.crud.boxes[h].fields[u].sourceSelectDoc !== null) {
                                for (let n = 0; n < data.crud.boxes[h].fields[u].sourceSelectDoc.length; n++) {
                                    doc.push(data.crud.boxes[h].fields[u].sourceSelectDoc[n]);
                                }
                            }

                            let selectFilters = [];
                            if (data.crud.boxes[h].fields[u].dataSource.length > 0) {
                                for (let p1 = 0; p1 < data.crud.boxes.length; p1++) {
                                    for (let a1 = 0; a1 < data.crud.boxes[p1].fields.length; a1++) {
                                        for (let bv = 0; bv < data.crud.boxes[h].fields[u].dataSource.length; bv++) {
                                            if (Number(data.crud.boxes[p1].fields[a1].id) === Number(data.crud.boxes[h].fields[u].dataSource[bv])) {
                                                if (data.crud.boxes[p1].fields[a1].idFieldTable)
                                                    selectFilters.push(data.crud.boxes[p1].fields[a1].idFieldTable)
                                            }
                                        }
                                    }
                                }
                            }
                            arrayTables.push({
                                table: `${user.data.instance}.${data.crud.boxes[h].fields[u].sourceSelect}`,
                                doc: [],
                                selectFilters: selectFilters,
                                whereFilters: whereFilters
                            })
                        }
                    }

                    if (data.crud.boxes[h].fields[u].searchSource !== null) {
                        let arraySearchSource = [];
                        for (let q = 0; q < data.crud.boxes[h].fields[u].searchSource.length; q++) {
                            for (let e = 0; e < data.crud.boxes.length; e++) {
                                for (let w = 0; w < data.crud.boxes[e].fields.length; w++) {
                                    if (data.crud.boxes[e].fields[w].id === data.crud.boxes[h].fields[u].searchSource[q]) {
                                        arraySearchSource.push(data.crud.boxes[e].fields[w]);
                                    }
                                    //modificacion 210725
                                    if (data.crud.boxes[e].fields[w].group !== null) {

                                        for (let w1 = 0; w1 < data.crud.boxes[e].fields[w].group.length; w1++) {
                                            if (data.crud.boxes[e].fields[w].group[w1].design === 'fieldsNoAdd') {
                                                for (let w2 = 0; w2 < data.crud.boxes[e].fields[w].group[w1].fields.length; w2++) {
                                                    if (data.crud.boxes[e].fields[w].group[w1].fields[w2].id === data.crud.boxes[h].fields[u].searchSource[q]) {
                                                        let objectFieldsNoAdd = JSON.parse(JSON.stringify(data.crud.boxes[e].fields[w].group[w1].fields[w2]));
                                                        objectFieldsNoAdd.fieldsNoAdd = true;
                                                        arraySearchSource.push(objectFieldsNoAdd);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    //modificacion 210725
                                }
                            }
                        }

                        arrayFieldsSource.push({
                            id: data.crud.boxes[h].fields[u].id,
                            idFieldTable: data.crud.boxes[h].fields[u].idFieldTable,
                            type: data.crud.boxes[h].fields[u].type,
                            search: data.crud.boxes[h].fields[u].search,
                            searchSource: arraySearchSource,
                            sourceSelect: data.crud.boxes[h].fields[u].sourceSelect,
                            orderBox: data.crud.boxes[h].order,
                            nameGroup: null,
                            index: null
                        });
                    }

                    if (data.crud.boxes[h].fields[u].group !== null) {

                        for (let t = 0; t < data.crud.boxes[h].fields[u].group.length; t++) {

                            for (let k = 0; k < data.crud.boxes[h].fields[u].group[t].fields.length; k++) {

                                if (data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelect !== null) {
                                    let existe = false;
                                    for (let y = 0; y < arrayTables.length; y++) {
                                        if (data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                            existe = true;
                                            if (data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length > 0) {
                                                let existeSelectFilter = false;
                                                for (let y1 = 0; y1 < arrayTables[y].selectFilters.length; y1++) {
                                                    if (arrayTables[y].selectFilters[y1] === data.crud.boxes[h].fields[u].group[t].fields[k].idFieldTable) {
                                                        existeSelectFilter = true;
                                                    }
                                                }
                                                if (!existeSelectFilter) {
                                                    arrayTables[y].selectFilters.push(data.crud.boxes[h].fields[u].group[t].fields[k].idFieldTable);
                                                }
                                            }
                                        }
                                    }
                                    if (existe === false) {
                                        let doc = [];
                                        if (data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelectDoc !== null) {
                                            for (let n = 0; n < data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelectDoc.length; n++) {
                                                doc.push(data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelectDoc[n]);
                                            }
                                        }
                                        let selectFilters = [];
                                        if (data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length > 0) {
                                            for (let p1 = 0; p1 < data.crud.boxes.length; p1++) {
                                                for (let a1 = 0; a1 < data.crud.boxes[p1].fields.length; a1++) {
                                                    for (let bv = 0; bv < data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length; bv++) {
                                                        if (Number(data.crud.boxes[p1].fields[a1].id) === Number(data.crud.boxes[h].fields[u].group[t].fields[k].dataSource[bv])) {
                                                            selectFilters.push(data.crud.boxes[p1].fields[a1].idFieldTable)
                                                        }
                                                    }

                                                    if (data.crud.boxes[p1].fields[a1].group !== null) {
                                                        for (let b1 = 0; b1 < data.crud.boxes[p1].fields[a1].group.length; b1++) {
                                                            for (let c1 = 0; c1 < data.crud.boxes[h].fields[u].group[b1].fields.length; c1++) {
                                                                for (let bv = 0; bv < data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length; bv++) {
                                                                    if (Number(data.crud.boxes[h].fields[u].group[b1].fields[c1].id) === Number(data.crud.boxes[h].fields[u].group[t].fields[k].dataSource[bv])) {
                                                                        selectFilters.push(data.crud.boxes[h].fields[u].group[b1].fields[c1].idFieldTable)
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        arrayTables.push({
                                            table: `${user.data.instance}.${data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelect}`,
                                            doc: [],
                                            selectFilters: selectFilters,
                                            whereFilters: whereFilters
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }

            let mainTables = [];
            for (let u = 0; u < data.crud.boxes.length; u++) {
                for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                    if (data.crud.boxes[u].fields[v].group === null) {
                        let existe = false;
                        for (let g = 0; g < mainTables.length; g++) {
                            if (mainTables[g].table === `${user.data.instance}.${data.crud.boxes[u].fields[v].table}`) {
                                existe = true;
                            }
                        }
                        if (existe === false) {
                            mainTables.push({ table: `${user.data.instance}.${data.crud.boxes[u].fields[v].table}`, fk: data.crud.boxes[u].fields[v].idFieldTable })
                        }
                    }
                }
            }

            const responseTables = await informationService.viewTables();

            //if (arrayTables.length > 0) {
            let searchTable = `${user.data.instance}.${data.list.view}`;

            for (let r = 0; r < responseTables.data.length; r++) {
                for (let y = 0; y < arrayTables.length; y++) {
                    let tableFlag = arrayTables[y].table.split('.');
                    if (tableFlag[1] === responseTables.data[r].name) {
                        arrayTables[y].table = `wbSys.${tableFlag[1]}`
                    }
                }
                if (responseTables.data[r].name === data.list.view) {
                    searchTable = `wbSys.${data.list.view}`
                }
                for (let y = 0; y < mainTables.length; y++) {
                    let tableFlag = mainTables[y].table.split('.');
                    if (tableFlag[1] === responseTables.data[r].name) {
                        mainTables[y].table = `wbSys.${tableFlag[1]}`
                    }
                }
            }

            initialDocHeader(data, null);
            initialDocGroup(data, null);
            let recordPrint = await loadRecord(idRecord, [], searchTable, mainTables, user, data, 'r', currencys);
            return recordPrint;
        }
    }
}

const loadRecord = async (id, arrayResponse, searchTable, mainTables, user, data, mode, currencys) => {

    let whereParam = parseQueryParams();
    let whereFieldsPF = JSON.parse(JSON.stringify(whereParam))
    filterByTradeAccountIdManagerId(whereFieldsPF);

    //BUSCAR REGISTRO
    let tradeAccountIdsr = null;
    let managerIdsr = null;
    whereFieldsPF.forEach((item) => {
        if (item.idField === 'tradeAccountId') {
            tradeAccountIdsr = item.value
        }
        if (item.idField === 'managerId') {
            managerIdsr = item.value
        }
    })

    const response = await informationService.searchRecord(
        `${searchTable}`,
        id,
        tradeAccountIdsr,
        managerIdsr
    );

    if (Object.keys(response.data).length !== 0) {

        for (let key in response.data) {
            for (let u = 0; u < data.crud.boxes.length; u++) {
                for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                    if (data.crud.boxes[u].fields[v].group === null) {
                        if (data.crud.boxes[u].fields[v].idFieldTable === key) {
                            let clave = data.crud.boxes[u].fields[v].id;
                            let value = response.data[key];
                            if (data.crud.boxes[u].fields[v].type === 'Select') {
                                let newValue = null;
                                for (let b = 0; b < arrayResponse.length; b++) {
                                    if (arrayResponse[b].source === data.crud.boxes[u].fields[v].sourceSelect && arrayResponse[b].id === value) {
                                        let idFlag = arrayResponse[b].id;
                                        let labelFlag = (arrayResponse[b].nameAlt !== '' && arrayResponse[b].nameAlt !== undefined && arrayResponse[b].nameAlt !== null) ? `${arrayResponse[b].name} ${arrayResponse[b].nameAlt}` : arrayResponse[b].name;
                                        newValue = {
                                            'id': idFlag,
                                            'label': labelFlag
                                        }
                                        if (idFlag !== undefined && labelFlag !== undefined)
                                            field[clave] = {
                                                'id': idFlag,
                                                'label': labelFlag
                                            }
                                    }
                                }
                                if (arrayResponse.length === 0) {
                                    let idFlag = response.data[key];
                                    let labelFlag = response.data[key.replace('Id', '')];
                                    newValue = {
                                        'id': idFlag,
                                        'label': labelFlag
                                    }
                                    field[clave] = {
                                        'id': idFlag,
                                        'label': labelFlag
                                    }

                                }
                                await searchFieldSource(data.crud.boxes[u].fields[v], newValue, null, null, data, 'r', currencys, null);
                            } else {
                                if (data.crud.boxes[u].fields[v].type === 'Date' && value !== null) {
                                    value = value.substring(0, 10);
                                }
                                if (data.crud.boxes[u].fields[v].type === 'Checkbox' || data.crud.boxes[u].fields[v].type === 'Switch') {

                                    if (value === '1') {
                                        value = true;

                                    } else {
                                        value = false;
                                    }
                                }
                                if ((data.crud.boxes[u].fields[v].type === 'Currency' || data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) && value !== null) {

                                    if (data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                        let fix = 0;
                                        let flag = data.crud.boxes[u].fields[v].type.split('age');
                                        if (flag.length > 1) {
                                            fix = (flag[1]);
                                        }
                                        value = (Number(value) * 100).toFixed(fix);
                                        value = value.toString();
                                    }
                                    value = value.replace(/\./g, ',');

                                    if (data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                        let step = 0;
                                        let decimalValueFlag;

                                        if (data.crud.boxes[u].fields[v].type.includes('Number'))
                                            decimalValueFlag = data.crud.boxes[u].fields[v].type.split('ber');
                                        if (data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                            decimalValueFlag = data.crud.boxes[u].fields[v].type.split('age');
                                        }
                                        if (decimalValueFlag.length > 1) {
                                            step = (decimalValueFlag[1]);
                                            let valueSplit = value.split(',');
                                            if (valueSplit.length > 1) {
                                                value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                            }
                                        }
                                        if (mode === 'r')
                                            value = formatNumberWithThousandsSeparator(value);
                                    }

                                    if (data.crud.boxes[u].fields[v].type === 'Currency') {
                                        //buscar currencyId
                                        let valueSplit = value.split(',');
                                        let step = 2;
                                        data.crud.boxes.forEach((itemBoxes) => {
                                            itemBoxes.fields.forEach((itemFields) => {
                                                if (itemFields.idFieldTable === 'currencyId') {
                                                    let valueResponse = itemFields.value;
                                                    let existe = false;

                                                    for (let g = 0; g < currencys.length; g++) {
                                                        if (Number(currencys[g].id) === Number(valueResponse)) {
                                                            step = currencys[g].decimals;
                                                            existe = true;
                                                        }
                                                    }
                                                    if (existe === false) {
                                                        step = 2;
                                                    }
                                                }
                                            })
                                        })
                                        if (valueSplit.length > 1) {
                                            value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                        }
                                        if (mode === 'r')
                                            value = formatNumberWithThousandsSeparator(value);
                                    }
                                }
                                if (value !== null) {

                                    field[clave] = value;

                                    await searchFieldSource(data.crud.boxes[u].fields[v], value, null, null, data, 'r', currencys, null);
                                }

                            }
                        }
                    }
                }
            }
        }


        for (let k = 0; k < mainTables.length; k++) {

            const responseSelect = await informationService.searchRecordGroup(`${mainTables[k].table}`, id, null, `${mainTables[k].fk}`);

            for (let h = 0; h < responseSelect.data.length; h++) {

                let trxLineTypeId = false;
                if (responseSelect.data[h].trxLineTypeId) {
                    if (responseSelect.data[h].trxLineTypeId !== '1') {
                        trxLineTypeId = true;
                    }
                } else {
                    trxLineTypeId = true;
                }
                if (trxLineTypeId) {
                    for (let key in responseSelect.data[h]) {
                        for (let u = 0; u < data.crud.boxes.length; u++) {
                            for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                                if (data.crud.boxes[u].fields[v].group === null) {
                                    if (data.crud.boxes[u].fields[v].idFieldTable === key && data.crud.boxes[u].fields[v].table === mainTables[k].table.split('.')[1]) {
                                        let clave = data.crud.boxes[u].fields[v].id;
                                        let value = responseSelect.data[h][key];
                                        if (data.crud.boxes[u].fields[v].type === 'Select') {
                                            for (let ab = 0; ab < arrayResponse.length; ab++) {
                                                if (arrayResponse[ab].source === data.crud.boxes[u].fields[v].sourceSelect) {
                                                    if (Number(value) === Number(arrayResponse[ab].id)) {
                                                        let labelFlag = (arrayResponse[ab].nameAlt !== '' && arrayResponse[ab].nameAlt !== undefined && arrayResponse[ab].nameAlt !== null) ? `${arrayResponse[ab].name} ${arrayResponse[ab].nameAlt}` : arrayResponse[ab].name;
                                                        if (value !== undefined && labelFlag !== undefined) {
                                                            let idValue = value;

                                                            field[clave] = {
                                                                'id': idValue,
                                                                'label': labelFlag
                                                            }
                                                        }

                                                    }
                                                }
                                            }
                                            if (arrayResponse.length === 0) {
                                                let idFlag = responseSelect.data[h][key];
                                                let labelFlag = responseSelect.data[h][key.replace('Id', '')];
                                                field[clave] = {
                                                    'id': idFlag,
                                                    'label': labelFlag
                                                }

                                            }
                                        } else {
                                            if (data.crud.boxes[u].fields[v].type === 'Date') {
                                                if (value)
                                                    value = value.substring(0, 10);
                                            }
                                            if (data.crud.boxes[u].fields[v].type === 'Checkbox' || data.crud.boxes[u].fields[v].type === 'Switch') {

                                                if (value === '1') {
                                                    value = true;

                                                } else {
                                                    value = false;
                                                }
                                            }
                                            if (data.crud.boxes[u].fields[v].type === 'Currency' || data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                if (value) {

                                                    if (data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                        let fix = 0;
                                                        let flag = data.crud.boxes[u].fields[v].type.split('age');
                                                        if (flag.length > 1) {
                                                            fix = (flag[1]);
                                                        }
                                                        value = (Number(value) * 100).toFixed(fix);
                                                        value = value.toString();
                                                    }

                                                    value = value.replace(/\./g, ',');

                                                    if (data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                        let step = 0;
                                                        let decimalValueFlag
                                                        if (data.crud.boxes[u].fields[v].type.includes('Number'))
                                                            decimalValueFlag = data.crud.boxes[u].fields[v].type.split('ber');
                                                        if (data.crud.boxes[u].fields[v].type.includes('Percentage'))
                                                            decimalValueFlag = data.crud.boxes[u].fields[v].type.split('age');
                                                        if (decimalValueFlag.length > 1) {
                                                            step = (decimalValueFlag[1]);
                                                            let valueSplit = value.split(',');
                                                            if (valueSplit.length > 1) {
                                                                value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                            }
                                                        }
                                                        if (mode === 'r')
                                                            value = formatNumberWithThousandsSeparator(value);
                                                    }

                                                    if (data.crud.boxes[u].fields[v].type === 'Currency') {
                                                        //buscar currencyId

                                                        let valueSplit = value.split(',');
                                                        let step = 2;
                                                        data.crud.boxes.forEach((itemBoxes) => {
                                                            itemBoxes.fields.forEach((itemFields) => {
                                                                if (itemFields.idFieldTable === 'currencyId') {
                                                                    let valueResponse = itemFields.value;
                                                                    let existe = false;

                                                                    for (let g = 0; g < currencys.length; g++) {
                                                                        if (Number(currencys[g].id) === Number(valueResponse)) {
                                                                            step = currencys[g].decimals;
                                                                            existe = true;
                                                                        }
                                                                    }
                                                                    if (existe === false) {
                                                                        step = 2;
                                                                    }
                                                                }
                                                            })
                                                        })
                                                        if (valueSplit.length > 1) {
                                                            value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                        }

                                                        if (mode === 'r')
                                                            value = formatNumberWithThousandsSeparator(value);
                                                    }
                                                }
                                            }
                                            if (value !== null)
                                                field[clave] = value

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        //BUSCAR GRUPOS DEL REGISTRO
        let tableGroup = [];
        for (let u = 0; u < data.crud.boxes.length; u++) {
            for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                if (data.crud.boxes[u].fields[v].group !== null) {
                    for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {

                        let viewGroup = data.crud.boxes[u].fields[v].group[b].view;

                        for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {
                            if (data.crud.boxes[u].fields[v].group[b].fields[m].table !== null) {
                                if (tableGroup.length === 0) {
                                    if (data.crud.boxes[u].fields[v].group[b].fields[m].idFieldTable.toUpperCase() !== 'ID')
                                        tableGroup.push({
                                            table: viewGroup,
                                            tableSelect: data.crud.boxes[u].fields[v].group[b].fields[m].table,
                                            group: data.crud.boxes[u].fields[v].group[b].name,
                                            field: data.crud.boxes[u].fields[v].group[b].fields[m].idFieldTable,
                                        });
                                } else {
                                    let existe = false;
                                    for (let p = 0; p < tableGroup.length; p++) {

                                        let validateFlag = false;

                                        if (viewGroup === tableGroup[p].table && data.crud.boxes[u].fields[v].group[b].name === tableGroup[p].group)
                                            validateFlag = true
                                        if (validateFlag) {
                                            existe = true;
                                        }
                                    }
                                    if (existe === false) {
                                        tableGroup.push({
                                            table: viewGroup,
                                            tableSelect: data.crud.boxes[u].fields[v].group[b].fields[m].table,
                                            group: data.crud.boxes[u].fields[v].group[b].name,
                                            field: data.crud.boxes[u].fields[v].group[b].fields[m].idFieldTable,
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        const responseTables = await informationService.viewTables();

        for (let g = 0; g < tableGroup.length; g++) {
            tableGroup[g].table = `${user.data.instance}.${tableGroup[g].table}`;
            tableGroup[g].tableSelect = `${user.data.instance}.${tableGroup[g].tableSelect}`;
            for (let r = 0; r < responseTables.data.length; r++) {
                let tableFlag = tableGroup[g].table.split('.');
                let tableFlag1 = tableGroup[g].tableSelect.split('.');

                if (tableFlag[1] === responseTables.data[r].name) {
                    tableGroup[g].table = `wbSys.${tableFlag[1]}`
                }
                if (tableFlag1[1] === responseTables.data[r].name) {
                    tableGroup[g].tableSelect = `wbSys.${tableFlag1[1]}`
                }
            }
        }
        let idRequest = id;

        for (let i = 0; i < tableGroup.length; i++) {
            let tableSearch = tableGroup[i].table;
            let groupSearch = tableGroup[i].group;
            let fieldSearch = tableGroup[i].field;


            const responseSearchRecordGroup = await informationService.searchRecordGroup(`${tableSearch}`, idRequest, `${groupSearch}`, `${fieldSearch}`);

            let objectsGroups = [];
            //let designGroup = null;

            for (let h = 0; h < responseSearchRecordGroup.data.length; h++) {
                for (let u = 0; u < data.crud.boxes.length; u++) {
                    for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                        if (data.crud.boxes[u].fields[v].group !== null) {
                            for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {

                                let validateFlag = false;
                                if (mode !== 'r' && groupSearch === responseSearchRecordGroup.data[h].group) {
                                    validateFlag = true;
                                } else {
                                    if (mode === 'r') {
                                        validateFlag = true;
                                    }
                                }
                                validateFlag = true;

                                if (validateFlag) {
                                    let validateFlag1 = false;
                                    if (data.crud.boxes[u].fields[v].group[b].name === responseSearchRecordGroup.data[h].nameGroup) {
                                        validateFlag1 = true;
                                    }
                                    if (validateFlag1) {

                                        let objectGroup = {};
                                        let arrayFields = [];
                                        //designGroup = data.crud.boxes[u].fields[v].group[b].design;
                                        for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {

                                            let itemFlag = JSON.parse(JSON.stringify(data.crud.boxes[u].fields[v].group[b].fields[m]));
                                            let tamano = objectsGroups.length;
                                            let newIdField = m + '_' + data.crud.boxes[u].fields[v].group[b].fields[m].id + '_' + m + tamano;
                                            itemFlag.id = newIdField;
                                            itemFlag.isGroup = true;

                                            //buscar y reemplazar id de los where
                                            if (itemFlag.where !== null) {
                                                for (let r = 0; r < itemFlag.where.length; r++) {
                                                    if (itemFlag.where[r].field.length !== null) {
                                                        for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                            let idField = itemFlag.where[r].field[d].idField;
                                                            let existeIdGroup = false;

                                                            for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                                if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                                    let tamano1 = objectsGroups.length;
                                                                    let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                                    itemFlag.where[r].field[d].idField = newIdField1;
                                                                    existeIdGroup = true;
                                                                }
                                                            }

                                                            if (existeIdGroup === false) {
                                                                let newIdField1 = idField;
                                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            //buscar y reemplazar id de los search source
                                            if (itemFlag.searchSource !== null) {
                                                for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                                    let idField = itemFlag.searchSource[r];
                                                    let existeIdGroup = false;
                                                    for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                        if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                            let tamano1 = objectsGroups.length;
                                                            let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                            itemFlag.searchSource[r] = newIdField1;
                                                            existeIdGroup = true;
                                                        }
                                                    }

                                                    if (existeIdGroup === false) {
                                                        let newIdField1 = idField;
                                                        itemFlag.searchSource[r] = newIdField1;
                                                    }
                                                }
                                            }

                                            arrayFields.push(itemFlag);
                                            let existeMap = false;

                                            for (let key in responseSearchRecordGroup.data[h]) {
                                                if (responseSearchRecordGroup.data[h][key] !== null) {
                                                    if (itemFlag.idFieldTable === key) {
                                                        existeMap = true;
                                                        let value = responseSearchRecordGroup.data[h][key];

                                                        let idField = itemFlag.id;
                                                        if ((itemFlag.type === 'Checkbox' || itemFlag.type === 'Switch') && value === '0') {
                                                            value = false
                                                        }
                                                        if ((itemFlag.type === 'Checkbox' || itemFlag.type === 'Switch') && value === '1') {
                                                            value = true
                                                        }
                                                        if (itemFlag.type === 'Currency' || itemFlag.type.includes('Number') || itemFlag.type.includes('Percentage')) {
                                                            if (itemFlag.type.includes('Percentage')) {
                                                                let fix = 0;
                                                                let flag = itemFlag.type.split('age');
                                                                if (flag.length > 1) {
                                                                    fix = (flag[1]);
                                                                }
                                                                value = (Number(value) * 100).toFixed(fix);
                                                                value = value.toString();
                                                            }
                                                            value = value.replace(/\./g, ',');
                                                            if (itemFlag.type.includes('Number') || itemFlag.type.includes('Percentage')) {
                                                                let step = 0;
                                                                let decimalValueFlag;
                                                                if (itemFlag.type.includes('Number'))
                                                                    decimalValueFlag = itemFlag.type.split('ber');
                                                                if (itemFlag.type.includes('Percentage'))
                                                                    decimalValueFlag = itemFlag.type.split('age');
                                                                if (decimalValueFlag.length > 1) {
                                                                    step = (decimalValueFlag[1]);
                                                                    let valueSplit = value.split(',');
                                                                    if (valueSplit.length > 1) {
                                                                        value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                    }
                                                                }
                                                                if (mode === 'r')
                                                                    value = formatNumberWithThousandsSeparator(value);
                                                            }
                                                            if (itemFlag.type === 'Currency') {
                                                                //buscar currencyId
                                                                let valueSplit = value.split(',');
                                                                let step = 2;
                                                                data.crud.boxes.forEach((itemBoxes) => {
                                                                    itemBoxes.fields.forEach((itemFields) => {
                                                                        if (itemFields.idFieldTable === 'currencyId') {
                                                                            let valueResponse = itemFields.value;
                                                                            let existe = false;

                                                                            for (let g = 0; g < currencys.length; g++) {
                                                                                if (Number(currencys[g].id) === Number(valueResponse)) {

                                                                                    step = currencys[g].decimals;
                                                                                    existe = true;
                                                                                }
                                                                            }
                                                                            if (existe === false) {

                                                                                step = 2;
                                                                            }
                                                                        }
                                                                    })
                                                                })
                                                                if (valueSplit.length > 1) {
                                                                    value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                }

                                                                if (mode === 'r') {
                                                                    value = formatNumberWithThousandsSeparator(value);
                                                                }
                                                            }
                                                        }

                                                        if (itemFlag.type === 'Select') {
                                                            for (let ab = 0; ab < arrayResponse.length; ab++) {
                                                                if (arrayResponse[ab].source === itemFlag.sourceSelect) {
                                                                    if (Number(value) === Number(arrayResponse[ab].id)) {
                                                                        let labelFlag = (arrayResponse[ab].nameAlt !== '' && arrayResponse[ab].nameAlt !== undefined && arrayResponse[ab].nameAlt !== null) ? `${arrayResponse[ab].name} ${arrayResponse[ab].nameAlt}` : arrayResponse[ab].name;
                                                                        if (value !== undefined && labelFlag !== undefined)
                                                                            value = {
                                                                                'id': value,
                                                                                'label': labelFlag
                                                                            }

                                                                    }
                                                                }
                                                            }
                                                            if (arrayResponse.length === 0) {
                                                                let idFlag = responseSearchRecordGroup.data[h][key];
                                                                let labelFlag = responseSearchRecordGroup.data[h][key.replace('Id', '')];
                                                                value = {
                                                                    'id': idFlag,
                                                                    'label': labelFlag
                                                                }
                                                            }
                                                        }

                                                        field[idField] = value;

                                                        itemFlag.valueTemporal = value;

                                                        if (itemFlag.searchSource !== null && (value === null || value === undefined)) {
                                                            //setValueSearchSource(itemFlag, idField, arrayFields, arrayResponse);
                                                        }
                                                    }
                                                }
                                            }

                                            if (existeMap === false) {

                                                let idField = itemFlag.id;

                                                if (itemFlag.type === 'Select') {
                                                    field[idField] = null;

                                                } else {
                                                    field[idField] = '';
                                                }
                                                itemFlag.valueTemporal = null;

                                                if (itemFlag.searchSource !== null) {
                                                    //setValueSearchSource(itemFlag, idField, arrayFields, arrayResponse);
                                                }
                                            }
                                        }
                                        objectGroup.fields = arrayFields;
                                        objectGroup.doc = responseSearchRecordGroup.data[h].doc
                                        objectsGroups.push(objectGroup);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (objectsGroups.length > 0) {

                group[groupSearch] = objectsGroups;

            } else {
                for (let u = 0; u < data.crud.boxes.length; u++) {
                    for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                        if (data.crud.boxes[u].fields[v].group !== null) {
                            for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {
                                if (groupSearch === data.crud.boxes[u].fields[v].group[b].name) {
                                    let objectGroup = {};
                                    let arrayFields = [];
                                    for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {

                                        let itemFlag = JSON.parse(JSON.stringify(data.crud.boxes[u].fields[v].group[b].fields[m]));
                                        let tamano = objectsGroups.length;
                                        let newIdField = m + '_' + data.crud.boxes[u].fields[v].group[b].fields[m].id + '_' + m + tamano;
                                        itemFlag.id = newIdField;
                                        itemFlag.isGroup = true;

                                        //buscar y reemplazar id de los where
                                        if (itemFlag.where !== null) {
                                            for (let r = 0; r < itemFlag.where.length; r++) {
                                                if (itemFlag.where[r].field.length !== null) {
                                                    for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                        let idField = itemFlag.where[r].field[d].idField;
                                                        let existeIdGroup = false;

                                                        for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                            if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                                let tamano1 = objectsGroups.length;
                                                                let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                                existeIdGroup = true;
                                                            }
                                                        }

                                                        if (existeIdGroup === false) {
                                                            let newIdField1 = idField;
                                                            itemFlag.where[r].field[d].idField = newIdField1;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        //buscar y reemplazar id de los search source
                                        if (itemFlag.searchSource !== null) {
                                            for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                                let idField = itemFlag.searchSource[r];
                                                let existeIdGroup = false;
                                                for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                    if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                        let tamano1 = objectsGroups.length;
                                                        let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                        itemFlag.searchSource[r] = newIdField1;
                                                        existeIdGroup = true;
                                                    }
                                                }

                                                if (existeIdGroup === false) {
                                                    let newIdField1 = idField;
                                                    itemFlag.searchSource[r] = newIdField1;
                                                }
                                            }
                                        }
                                        arrayFields.push(itemFlag);
                                        switch (itemFlag.type) {
                                            case 'Select':
                                                if (itemFlag.defaultValue) {
                                                    /*info.forEach((itemInfo) => {
                                                        if (itemInfo.source === itemFlag.sourceSelect) {
                                                            if (Number(itemFlag.defaultValue) === Number(itemInfo.id))

                                                                field[newIdField] = {
                                                                    id: itemInfo.id,
                                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                }
                                                        }
                                                    })*/
                                                } else {
                                                    field[newIdField] = null;
                                                }
                                                break;
                                            case 'MultipleSelect':
                                                field[newIdField] = null;
                                                break;
                                            case 'List':
                                                field[newIdField] = null;
                                                break;
                                            case 'Checkbox':
                                                field[newIdField] = false;
                                                break;
                                            case 'Switch':
                                                field[newIdField] = false;
                                                break;
                                            case 'Number':
                                                field[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                                break;
                                            case 'Currency':
                                                field[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                                break;
                                            case 'Date':

                                                if (itemFlag.defaultValue === 'CURDATE()') {
                                                    field[newIdField] = new Date().toISOString().split('T')[0]
                                                } else {
                                                    if (itemFlag.defaultValue === 'BOM()') {
                                                        const date = new Date();
                                                        date.setDate(1);
                                                        field[newIdField] = date.toISOString().split('T')[0]
                                                    } else {
                                                        if (itemFlag.defaultValue === 'BOY()') {
                                                            const date = new Date();
                                                            date.setMonth(0); // Enero
                                                            date.setDate(1);  // Día 1
                                                            field[newIdField] = date.toISOString().split('T')[0]
                                                        } else {
                                                            if (itemFlag.defaultValue === 'YESTARDAY()') {
                                                                const date = new Date();
                                                                date.setDate(date.getDate() - 1);
                                                                field[newIdField] = date.toISOString().split('T')[0]
                                                            } else {
                                                                field[newIdField] = ''
                                                            }
                                                        }
                                                    }
                                                }
                                                break;
                                            default:
                                                field[newIdField] = itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                                break;
                                        }


                                    }
                                    objectGroup.fields = arrayFields;
                                    objectsGroups.push(objectGroup);
                                }
                            }
                        }
                    }
                }
                group[groupSearch] = objectsGroups;
            }

        }

        return {
            field,
            group,
            data
        }
    }
    return null;
}

const renderFieldsPrintTicket = (data, box, field, group) => {
    const dataEstructura = data;
    return dataEstructura.crud.boxes
        .filter((boxItem) => boxItem.box === box)
        .map((boxItem) => {
            let line = [];
            return boxItem.fields.map((itemFields, index) => {

                if (itemFields.display === 'hidden') return null;
                if (itemFields.group === null) {
                    let view = true;
                    if (itemFields.where !== null && itemFields.where !== undefined)
                        view = whereFunction(itemFields, field);

                    if (view === true) {
                        let textValue = "";
                        switch (itemFields.type) {
                            case 'Typography':
                                textValue = itemFields.defaultValue;
                                break;
                            case 'Select':
                                textValue = itemFields.name
                                    ? itemFields.name + " " + (field[itemFields.id].label || "")
                                    : field[itemFields.id].label || "";
                                break;
                            case 'Date':
                                if (field[itemFields.id]) {
                                    let dateSplit = field[itemFields.id].split('-');
                                    let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (dateNow || "")
                                        : dateNow || "";
                                } else {
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + ("" || "")
                                        : "" || "";
                                }
                                break;
                            default:
                                textValue = itemFields.name
                                    ? itemFields.name + " " + (field[itemFields.id] || "")
                                    : field[itemFields.id] || "";
                                break;
                        }

                        if (itemFields.type.toUpperCase().includes('PERCENT')) {
                            textValue = textValue + "%";
                        }
                        let comparateIdFieldTable = itemFields.idFieldTable ? itemFields.idFieldTable : "";
                        let logoName = null;
                        if (comparateIdFieldTable.toUpperCase().includes('IMG')) {

                            let splitLogoName = field[itemFields.id].split('/');
                            logoName = splitLogoName[splitLogoName.length - 1];
                        }
                        const element = comparateIdFieldTable.toUpperCase().includes('IMG') ? (
                            <image.renderLogo logoName={logoName !== null ? logoName : 'WINVEST_LOGO_color.png'} />
                        ) : (
                            <>
                                <Text key={index} style={[styles.sectionText, { fontFamily: (box === 'header4w50' && itemFields.idFieldTable === 'printName') ? 'Helvetica-Bold' : 'Helvetica', fontWeight: (box === 'header4w50' && itemFields.idFieldTable === 'printName') ? 'bold' : '' }]}>{textValue}</Text>
                                <Text key={index} style={styles.sectionText}> </Text>
                            </>
                        );
                        // Si columnBreak es true, agregamos la línea actual y empezamos otra
                        if (itemFields.columnBreak) {
                            const currentLine = [...line, element];
                            line = [];
                            return <View key={`line-${index}`}
                                style={{
                                    flexDirection: 'row', flexWrap: 'wrap',
                                    padding: (`${box}` === 'header4w50') ? 8 : 1,
                                    borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                    justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                }}>
                                {currentLine}
                            </View>;
                        } else {
                            line.push(element);
                            // Si es el último campo, devolvemos la línea
                            if (index === boxItem.fields.length - 1) {
                                return <View key={`line-${index}`}
                                    style={{
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        padding: (`${box}` === 'header4w50') ? 8 : (`${box}` === 'footer2w50') ? 14 : 1,
                                        borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                        justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                    }}
                                >
                                    {line}
                                </View>;
                            }
                            return null; // seguimos acumulando
                        }
                    }
                    return null;

                } else {

                    return itemFields.group.map((itemFieldsGroup, gIndex) => {
                        const nameGroup = itemFieldsGroup.name;

                        const items = group[nameGroup] || [];
                        const rows = [];
                        let importe = 0;
                        let cantidad = 0;
                        for (let i = 0; i < items.length; i++) {
                            if (i === 0) {
                                rows.push(
                                    <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', borderBottom: (`${box}` === 'header4w50' || `${box}` === 'body1w100') ? "1px solid #000" : '' }}>
                                        {items[i].fields.map((rowItem, colIndex) => {
                                            if (rowItem.display !== 'hidden' && rowItem.name) {

                                                let view = true;
                                                if (rowItem.where !== null && rowItem.where !== undefined)
                                                    view = whereFunction(rowItem, field);

                                                if (view === true) {
                                                    return <View key={`col-${colIndex}`}
                                                        style={{
                                                            flex: 1,
                                                            textAlign: "center",
                                                            borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                            padding: 4
                                                        }}

                                                    >
                                                        <Text style={styles.sectionText}>
                                                            {rowItem.name}
                                                        </Text>
                                                    </View>
                                                }
                                                return null;
                                            }
                                            return null;
                                        })}
                                    </View>
                                );
                            }

                            if (box === 'body1w100') {
                                for (const rowItem of items[i].fields) {
                                    if (rowItem.display !== 'hidden') {
                                        if (rowItem.idFieldTable === 'qty') {
                                            let qtyRow = field[rowItem.id].toString().replace(/\./g, '');
                                            qtyRow = qtyRow.toString().replace(/,/g, '.');
                                            cantidad = (Number(cantidad) + Number(qtyRow)).toFixed(4)
                                        }
                                        if (rowItem.idFieldTable === 'amount') {
                                            let amountRow = field[rowItem.id].toString().replace(/\./g, '');
                                            amountRow = amountRow.toString().replace(/,/g, '.');
                                            importe = (Number(importe) + Number(amountRow)).toFixed(2)
                                        }
                                    }

                                }

                            }
                            rows.push(
                                <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', justifyContent: `${box}` === 'header4w50' ? 'center' : 'left' }}>
                                    {items[i].fields.map((rowItem, colIndex) => {
                                        if (rowItem.display !== 'hidden') {

                                            let view = true;
                                            if (rowItem.where !== null && rowItem.where !== undefined)
                                                view = whereFunction(rowItem, field);

                                            if (view === true) {
                                                let textValue = "";
                                                switch (rowItem.type) {
                                                    case 'Typography':
                                                        textValue = rowItem.defaultValue;
                                                        break;
                                                    case 'Select':
                                                        textValue = field[rowItem.id] ? field[rowItem.id].label : "";
                                                        break;
                                                    case 'Date':
                                                        if (field[rowItem.id]) {
                                                            let dateSplit = field[rowItem.id].split('-');
                                                            let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                                            textValue = dateNow;
                                                        } else {
                                                            textValue = "";
                                                        }
                                                        break;
                                                    default:
                                                        textValue = field[rowItem.id];
                                                        break;
                                                }

                                                if (rowItem.type.toUpperCase().includes('PERCENT')) {
                                                    textValue = textValue + "%";
                                                }

                                                let formatNumber = false;
                                                if (rowItem.type.toUpperCase().includes('PERCEN') || rowItem.type.toUpperCase().includes('CURRENCY') || rowItem.type.toUpperCase().includes('NUMBER')) {
                                                    formatNumber = true;
                                                }
                                                if (textValue !== '%') {
                                                    return <View
                                                        key={`col-${colIndex}`}
                                                        style={{
                                                            flex: (`${box}` !== 'body3w50') ? 1 : null,
                                                            width: (`${box}` === 'body3w50') ?
                                                                (rowItem.idFieldTable === 'itemPropertyId') ? '150px' :
                                                                    (rowItem.idFieldTable === 'rate') ? '45px' :
                                                                        (rowItem.idFieldTable === 'amount') ? '70px'
                                                                            : '98px'
                                                                : null,
                                                            fontSize: `${box}` === 'body3w50' ? 5 : 9,
                                                            borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                            padding: `${box}` !== 'body3w50' ? 4 : 1,
                                                        }}
                                                    >
                                                        <Text
                                                            style={[
                                                                styles.sectionText,
                                                                {
                                                                    textAlign:
                                                                        `${box}` === 'header4w50'
                                                                            ? 'center'
                                                                            : `${box}` === 'body1w100' && colIndex < 7
                                                                                ? 'right'
                                                                                : `${box}` === 'body1w100' && colIndex > 7
                                                                                    ? 'center'
                                                                                    : `${box}` === 'body3w50' && formatNumber
                                                                                        ? 'right'
                                                                                        : 'left',
                                                                },
                                                            ]}
                                                        >
                                                            {textValue}
                                                        </Text>
                                                    </View>
                                                }
                                                return null;
                                            }
                                            return null;
                                        }
                                        return null;
                                    })}
                                </View>
                            );
                        }
                        if (box === 'body1w100') {
                            rows.push(
                                <>
                                    <View key={`row-totales`} style={{ flexDirection: 'row', justifyContent: 'left', borderTop: "1px solid #000" }}>

                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1
                                            }}
                                        >
                                            <Text style={[styles.sectionText, { textAlign: "right", marginRight: 3 }]}>
                                                {formatNumber(cantidad)}
                                            </Text>
                                        </View>
                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1
                                            }}
                                        ></View>
                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1,
                                                padding: 1
                                            }}
                                        >
                                            <Text style={[styles.sectionText, { textAlign: "right" }]}>
                                                {formatNumber(importe)}
                                            </Text>
                                        </View>
                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1,
                                                padding: 1
                                            }}
                                        ></View>
                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1,
                                                padding: 1
                                            }}
                                        ></View>
                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1,
                                                padding: 1
                                            }}
                                        ></View>
                                        <View key={`col-totales`}
                                            style={{
                                                flex: 1,
                                                padding: 1
                                            }}
                                        ></View>

                                    </View>
                                </>
                            );
                        }

                        return <View key={`group-${gIndex}`}>{rows}</View>;

                    });
                }
            });
        })
}

const renderFieldsPrintDividens = (data, box, field, group) => {
    const dataEstructura = data;
    return dataEstructura.crud.boxes
        .filter((boxItem) => boxItem.box === box)
        .map((boxItem) => {
            let line = [];
            return boxItem.fields.map((itemFields, index) => {

                if (itemFields.display === 'hidden') return null;
                if (itemFields.group === null) {
                    let view = true;
                    if (itemFields.where !== null && itemFields.where !== undefined)
                        view = whereFunction(itemFields, field);

                    if (view === true) {
                        let textValue = "";
                        switch (itemFields.type) {
                            case 'Typography':
                                textValue = itemFields.defaultValue;
                                break;
                            case 'Select':
                                textValue = itemFields.name
                                    ? itemFields.name + " " + (field[itemFields.id].label || "")
                                    : field[itemFields.id].label || "";
                                break;
                            case 'Date':
                                if (field[itemFields.id]) {
                                    let dateSplit = field[itemFields.id].split('-');
                                    let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (dateNow || "")
                                        : dateNow || "";
                                } else {
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + ("" || "")
                                        : "" || "";
                                }
                                break;
                            default:
                                textValue = itemFields.name
                                    ? itemFields.name + " " + (field[itemFields.id] || "")
                                    : field[itemFields.id] || "";
                                break;
                        }

                        if (itemFields.type.toUpperCase().includes('PERCENT')) {
                            textValue = textValue + "%";
                        }
                        let comparateIdFieldTable = itemFields.idFieldTable ? itemFields.idFieldTable : "";
                        let logoName = null;
                        if (comparateIdFieldTable.toUpperCase().includes('IMG')) {

                            let splitLogoName = field[itemFields.id].split('/');
                            logoName = splitLogoName[splitLogoName.length - 1];
                        }
                        const element = comparateIdFieldTable.toUpperCase().includes('IMG') ? (
                            <image.renderLogo logoName={logoName !== null ? logoName : 'WINVEST_LOGO_color.png'} />
                        ) : (
                            <>
                                <Text key={index} style={[styles.sectionText, { fontFamily: (box === 'header4w50' && itemFields.idFieldTable === 'printName') ? 'Helvetica-Bold' : 'Helvetica', fontWeight: (box === 'header4w50' && itemFields.idFieldTable === 'printName') ? 'bold' : '' }]}>{textValue}</Text>
                                <Text key={index} style={styles.sectionText}> </Text>
                            </>
                        );
                        // Si columnBreak es true, agregamos la línea actual y empezamos otra
                        if (itemFields.columnBreak) {
                            const currentLine = [...line, element];
                            line = [];
                            return <View key={`line-${index}`}
                                style={{
                                    flexDirection: 'row', flexWrap: 'wrap',
                                    padding: (`${box}` === 'header4w50') ? 8 : 1,
                                    borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                    justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                }}>
                                {currentLine}
                            </View>;
                        } else {
                            line.push(element);
                            // Si es el último campo, devolvemos la línea
                            if (index === boxItem.fields.length - 1) {
                                return <View key={`line-${index}`}
                                    style={{
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        padding: (`${box}` === 'header4w50') ? 8 : (`${box}` === 'footer2w50') ? 14 : 1,
                                        borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                        justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                    }}
                                >
                                    {line}
                                </View>;
                            }
                            return null; // seguimos acumulando
                        }
                    }
                    return null;
                } else {

                    return itemFields.group.map((itemFieldsGroup, gIndex) => {
                        const nameGroup = itemFieldsGroup.name;

                        const items = group[nameGroup] || [];
                        const rows = [];

                        for (let i = 0; i < items.length; i++) {

                            if (i === 0) {
                                rows.push(
                                    <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', borderBottom: (`${box}` === 'header4w50' || `${box}` === 'body1w100') ? "1px solid #000" : '' }}>
                                        {items[i].fields.map((rowItem, colIndex) => {
                                            if (rowItem.display !== 'hidden' && rowItem.name) {
                                                let view = true;
                                                if (rowItem.where !== null && rowItem.where !== undefined)
                                                    view = whereFunction(rowItem, field);

                                                if (view === true) {
                                                    return <View key={`col-${colIndex}`}
                                                        style={{
                                                            flex: (`${box}` !== 'body1w100' && `${box}` !== 'body2w100') ? 1 : null,
                                                            width: (`${box}` === 'body1w100' || `${box}` === 'body2w100') ?
                                                                (rowItem.idFieldTable === 'lineSeq') ? '8%' :
                                                                    (`${box}` === 'body1w100' && rowItem.idFieldTable === 'symbol') ? '2%' :
                                                                        (`${box}` === 'body2w100' && rowItem.idFieldTable === 'symbol') ? '2%' :
                                                                            (rowItem.idFieldTable === 'date') ? '10%' :
                                                                                (rowItem.idFieldTable === 'holding') ? '10%' :
                                                                                    (rowItem.idFieldTable === 'name') ? '2%' :
                                                                                        (`${box}` === 'body1w100' && rowItem.idFieldTable === 'nameAlt') ? '13%' :
                                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'nameAlt') ? '10%' :
                                                                                                (`${box}` === 'body1w100' && rowItem.idFieldTable === 'itemId') ? '40%' :
                                                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'itemId') ? '40%' :
                                                                                                        (rowItem.idFieldTable === 'qty') ? '10%' :
                                                                                                            (rowItem.idFieldTable === 'rate') ? '10%' :
                                                                                                                (`${box}` === 'body1w100' && rowItem.idFieldTable === 'amountSigned') ? '10%' :
                                                                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'amountSigned') ? '10%'
                                                                                                                        : '80px'
                                                                : null,
                                                            /*width: (`${box}` === 'body1w100' || `${box}` === 'body2w100') ?
                                                                (rowItem.idFieldTable === 'lineSeq') ? '30px' :
                                                                    (rowItem.idFieldTable === 'date') ? '45px' :
                                                                        (rowItem.idFieldTable === 'holding') ? '70px' :
                                                                            (rowItem.idFieldTable === 'name') ? '20px' :
                                                                                (rowItem.idFieldTable === 'nameAlt') ? '70px' :
                                                                                    (rowItem.idFieldTable === 'itemId') ? '170px' :
                                                                                        (rowItem.idFieldTable === 'qty') ? '70px' :
                                                                                            (rowItem.idFieldTable === 'rate') ? '40px' :
                                                                                                (rowItem.idFieldTable === 'amountSigned') ? '80px'
                                                                                                    : '10px'
                                                                : null,*/
                                                            //textAlign: "center",
                                                            borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                            padding: 4
                                                        }}

                                                    >
                                                        <Text style={[
                                                            styles.sectionText,
                                                            { textAlign: `${box}` === 'body1w100' && rowItem.name === "Acreencia" ? "left" : "center" },
                                                            { marginLeft: `${box}` === 'body1w100' && rowItem.name === "Acreencia" ? 18 : 0 },
                                                        ]}>

                                                            {rowItem.name}
                                                        </Text>
                                                    </View>
                                                }
                                            }
                                            return null;
                                        })}
                                    </View>
                                );
                            }

                            rows.push(
                                <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', justifyContent: `${box}` === 'header4w50' ? 'center' : 'left' }}>
                                    {items[i].fields.map((rowItem, colIndex) => {
                                        if (rowItem.display !== 'hidden') {
                                            let view = true;
                                            if (rowItem.where !== null && rowItem.where !== undefined)
                                                view = whereFunction(rowItem, field);

                                            if (view === true) {
                                                let textValue = "";
                                                switch (rowItem.type) {
                                                    case 'Typography':
                                                        textValue = rowItem.defaultValue;
                                                        break;
                                                    case 'Select':
                                                        textValue = field[rowItem.id] ? field[rowItem.id].label : "";
                                                        break;
                                                    case 'Date':
                                                        if (field[rowItem.id]) {
                                                            let dateSplit = field[rowItem.id].split('-');
                                                            let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                                            textValue = dateNow;
                                                        } else {
                                                            textValue = "";
                                                        }
                                                        break;
                                                    default:
                                                        textValue = field[rowItem.id];
                                                        break;
                                                }

                                                if (rowItem.type.toUpperCase().includes('PERCENT')) {
                                                    textValue = textValue + "%";
                                                }

                                                let formatNumber = false;
                                                if (rowItem.type.toUpperCase().includes('PERCEN') || rowItem.type.toUpperCase().includes('CURRENCY') || rowItem.type.toUpperCase().includes('NUMBER')) {
                                                    formatNumber = true;
                                                }
                                                let isText = false;
                                                if (rowItem.type.toUpperCase().includes('TEXT') && rowItem.idFieldTable !== 'name') {
                                                    isText = true;
                                                }
                                                //if(textValue.length>24)
                                                //  textValue=textValue.substring(0,18);

                                                if (textValue !== '%') {
                                                    return <View
                                                        key={`col-${colIndex}`}
                                                        /*style={{
                                                            flex: (`${box}` !== 'body1w100' && `${box}` !== 'body2w100') ? 1 : null,
                                                            width: (`${box}` === 'body1w100' || `${box}` === 'body2w100') ?
                                                                (rowItem.idFieldTable === 'lineSeq') ? '30px' :
                                                                    (rowItem.idFieldTable === 'date') ? '45px' :
                                                                        (rowItem.idFieldTable === 'holding') ? '70px' :
                                                                            (rowItem.idFieldTable === 'name') ? '20px' :
                                                                                (`${box}` === 'body1w100' && rowItem.idFieldTable === 'nameAlt') ? '80px' :
                                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'nameAlt') ? '70px' :
                                                                                        (`${box}` === 'body1w100' && rowItem.idFieldTable === 'itemId') ? '170px' :
                                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'itemId') ? '190px' :
                                                                                                (rowItem.idFieldTable === 'qty') ? '60px' :
                                                                                                    (rowItem.idFieldTable === 'rate') ? '20px' :
                                                                                                        (`${box}` === 'body1w100' && rowItem.idFieldTable === 'amountSigned') ? '80px' :
                                                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'amountSigned') ? '90px'
                                                                                                                : '10px'
                                                                : null,
                                                            fontSize: `${box}` === 'body4w50' ? 5 : 9,
                                                            borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                            padding: `${box}` !== 'body4w50' ? 4 : 1,
                                                        }}*/
                                                        style={{
                                                            flex: (`${box}` !== 'body1w100' && `${box}` !== 'body2w100' && `${box}` !== 'body4w50') ? 1 : null,
                                                            width: (`${box}` === 'body1w100' || `${box}` === 'body2w100' || `${box}` === 'body4w50') ?
                                                                (`${box}` === 'body4w50' && rowItem.idFieldTable === 'itemPropertyId') ? '150%' :
                                                                    (`${box}` === 'body4w50' && rowItem.idFieldTable === 'rate') ? '10%' :
                                                                        (`${box}` === 'body4w50' && rowItem.idFieldTable === 'amountSigned') ? '30%' :
                                                                            (`${box}` === 'body4w50' && rowItem.idFieldTable === 'symbol') ? '30%' :
                                                                                (rowItem.idFieldTable === 'lineSeq') ? '8%' :
                                                                                    (`${box}` === 'body1w100' && rowItem.idFieldTable === 'symbol') ? '1%' :
                                                                                        (`${box}` === 'body2w100' && rowItem.idFieldTable === 'symbol') ? '1%' :
                                                                                            (rowItem.idFieldTable === 'date') ? '10%' :
                                                                                                (rowItem.idFieldTable === 'holding') ? '10%' :
                                                                                                    (rowItem.idFieldTable === 'name') ? '2%' :
                                                                                                        (`${box}` === 'body1w100' && rowItem.idFieldTable === 'nameAlt') ? '10%' :
                                                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'nameAlt') ? '10%' :
                                                                                                                (`${box}` === 'body1w100' && rowItem.idFieldTable === 'itemId') ? '40%' :
                                                                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'itemId') ? '33%' :
                                                                                                                        (`${box}` === 'body1w100' && rowItem.idFieldTable === 'qty') ? '10%' :
                                                                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'qty') ? '19%' :
                                                                                                                                (`${box}` === 'body1w100' && rowItem.idFieldTable === 'rate') ? '10%' :
                                                                                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'rate') ? '10%' :
                                                                                                                                        (`${box}` === 'body1w100' && rowItem.idFieldTable === 'amountSigned') ? '5%' :
                                                                                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'amountSigned') ? '5%'
                                                                                                                                                : '100%'
                                                                : null,
                                                            fontSize: `${box}` === 'body4w50' ? 5 : 9,
                                                            borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                            padding: `${box}` !== 'body4w50' ? 4 : 1,
                                                        }}
                                                    >
                                                        <Text
                                                            wrap={false}
                                                            style={[
                                                                styles.sectionText,
                                                                {
                                                                    //fontSize: `${box}` === 'body4w50' ? 8 : 9,
                                                                    textAlign:
                                                                        `${box}` === 'header4w50'
                                                                            ? 'center'
                                                                            : (`${box}` === 'body1w100' || `${box}` === 'body2w100' || `${box}` === 'body4w50') && (formatNumber || rowItem.idFieldTable) === 'symbol'
                                                                                ? 'right'
                                                                                : (`${box}` === 'body1w100' || `${box}` === 'body2w100') && isText
                                                                                    ? 'left'
                                                                                    : (`${box}` === 'body1w100' || `${box}` === 'body2w100') && !isText && !formatNumber
                                                                                        ? 'center'
                                                                                        : `${box}` === 'body4w50' && formatNumber
                                                                                            ? 'right'
                                                                                            : 'left',
                                                                },
                                                            ]}
                                                        >
                                                            {textValue}
                                                        </Text>
                                                    </View>
                                                }
                                                return null;
                                            }
                                            return null;
                                        }
                                        return null;
                                    })}
                                </View>
                            );
                        }

                        return <View key={`group-${gIndex}`}>{rows}</View>;

                    });
                }
            });
        })
}

const renderFieldsPrintLedger = (data, box, field, group) => {
    const dataEstructura = data;
    return dataEstructura.crud.boxes
        .filter((boxItem) => boxItem.box === box)
        .map((boxItem) => {
            let line = [];
            return boxItem.fields.map((itemFields, index) => {

                if (itemFields.display === 'hidden') {
                    if (line.length > 0) {
                        return <View key={`line-${index}`}
                            style={{
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                padding: (`${box}` === 'header4w50') ? 8 : (`${box}` === 'footer2w50') ? 14 : 1,
                                borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                            }}
                        >
                            {line}
                        </View>;
                    } else {
                        return null;
                    }
                } else {
                    if (itemFields.group === null) {

                        let view = true;
                        if (itemFields.where !== null && itemFields.where !== undefined)
                            view = whereFunction(itemFields, field);

                        if (view === true) {
                            let textValue = "";
                            switch (itemFields.type) {
                                case 'Typography':
                                    textValue = itemFields.defaultValue;
                                    break;
                                case 'Select':
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (field[itemFields.id].label || "")
                                        : field[itemFields.id].label || "";
                                    break;
                                case 'Date':
                                    if (field[itemFields.id]) {
                                        let dateSplit = field[itemFields.id].split('-');
                                        let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                        textValue = itemFields.name
                                            ? itemFields.name + " " + (dateNow || "")
                                            : dateNow || "";
                                    } else {
                                        textValue = itemFields.name
                                            ? itemFields.name + " " + ("" || "")
                                            : "" || "";
                                    }
                                    break;
                                default:
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (field[itemFields.id] || "")
                                        : field[itemFields.id] || "";
                                    break;
                            }

                            if (itemFields.type.toUpperCase().includes('PERCENT')) {
                                textValue = textValue + "%";
                            }
                            let comparateIdFieldTable = itemFields.idFieldTable ? itemFields.idFieldTable : "";
                            let logoName = null;
                            if (comparateIdFieldTable.toUpperCase().includes('IMG')) {
                                let splitLogoName = field[itemFields.id].split('/');
                                logoName = splitLogoName[splitLogoName.length - 1];
                            }
                            const element = comparateIdFieldTable.toUpperCase().includes('IMG') ? (
                                <image.renderLogo logoName={logoName !== null ? logoName : 'WINVEST_LOGO_color.png'} />
                            ) : (
                                <>
                                    <Text key={index} style={[styles.sectionText, { fontFamily: (box === 'header4w50' && itemFields.idFieldTable === 'printName') ? 'Helvetica-Bold' : 'Helvetica', fontWeight: (box === 'header4w50' && itemFields.idFieldTable === 'printName') ? 'bold' : '' }]}>{textValue}</Text>
                                    <Text key={index} style={styles.sectionText}> </Text>
                                </>
                            );
                            // Si columnBreak es true, agregamos la línea actual y empezamos otra
                            if (itemFields.columnBreak) {
                                const currentLine = [...line, element];
                                line = [];
                                return <View key={`line-${index}`}
                                    style={{
                                        flexDirection: 'row', flexWrap: 'wrap',
                                        padding: (`${box}` === 'header4w50') ? 8 : 1,
                                        borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                        justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                    }}>
                                    {currentLine}
                                </View>;
                            } else {
                                line.push(element);
                                // Si es el último campo, devolvemos la línea
                                if (index === boxItem.fields.length - 1) {

                                    return <View key={`line-${index}`}
                                        style={{
                                            flexDirection: 'row',
                                            flexWrap: 'wrap',
                                            padding: (`${box}` === 'header4w50') ? 8 : (`${box}` === 'footer2w50') ? 14 : 1,
                                            borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                            justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                        }}
                                    >
                                        {line}
                                    </View>;
                                }
                                return null; // seguimos acumulando
                            }
                        }
                        return null;

                    } else {

                        return itemFields.group.map((itemFieldsGroup, gIndex) => {
                            const nameGroup = itemFieldsGroup.name;

                            const items = group[nameGroup] || [];
                            const rows = [];

                            for (let i = 0; i < items.length; i++) {
                                if (i === 0) {
                                    rows.push(
                                        <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', borderBottom: (`${box}` === 'header4w50' || `${box}` === 'body2w100') ? "1px solid #000" : '' }}>
                                            {items[i].fields.map((rowItem, colIndex) => {
                                                if (rowItem.display !== 'hidden' && rowItem.name) {

                                                    let view = true;
                                                    if (rowItem.where !== null && rowItem.where !== undefined)
                                                        view = whereFunction(rowItem, field);

                                                    if (view === true) {
                                                        return <View key={`col-${colIndex}`}
                                                            style={{
                                                                flex: (`${box}` !== 'body2w100') ? 1 : null,
                                                                width: (`${box}` === 'body2w100') ?
                                                                    (rowItem.idFieldTable === 'itemPropertyItemProp') ? '20%' :
                                                                        (rowItem.idFieldTable === 'bankAccountType') ? '20%' :
                                                                            (rowItem.idFieldTable === 'bank') ? '30%' :
                                                                                (rowItem.idFieldTable === 'number') ? '15%' :
                                                                                    (rowItem.idFieldTable === 'amount') ? '15%'
                                                                                        : '98px'
                                                                    : null,

                                                                textAlign: `${box}` === 'body4w50' && rowItem.idFieldTable === 'amountWords' ? 'left' : "center",
                                                                borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                                padding: 4
                                                            }}

                                                        >
                                                            <Text style={styles.sectionText}>
                                                                {rowItem.name}
                                                            </Text>
                                                        </View>
                                                    }
                                                    return null;
                                                }
                                                return null;
                                            })}
                                        </View>
                                    );
                                }


                                rows.push(
                                    <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', justifyContent: `${box}` === 'header4w50' ? 'center' : 'left' }}>
                                        {items[i].fields.map((rowItem, colIndex) => {
                                            if (rowItem.display !== 'hidden') {

                                                let view = true;
                                                if (rowItem.where !== null && rowItem.where !== undefined)
                                                    view = whereFunction(rowItem, field);

                                                if (view === true) {
                                                    let textValue = "";
                                                    switch (rowItem.type) {
                                                        case 'Typography':
                                                            textValue = rowItem.defaultValue;
                                                            break;
                                                        case 'Select':
                                                            textValue = field[rowItem.id] ? field[rowItem.id].label : "";
                                                            break;
                                                        case 'Date':
                                                            if (field[rowItem.id]) {
                                                                let dateSplit = field[rowItem.id].split('-');
                                                                let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                                                textValue = dateNow;
                                                            } else {
                                                                textValue = "";
                                                            }
                                                            break;
                                                        default:
                                                            textValue = field[rowItem.id];
                                                            break;
                                                    }

                                                    if (rowItem.type.toUpperCase().includes('PERCENT')) {
                                                        textValue = textValue + "%";
                                                    }

                                                    let formatNumber = false;
                                                    if (rowItem.type.toUpperCase().includes('PERCEN') || rowItem.type.toUpperCase().includes('CURRENCY') || rowItem.type.toUpperCase().includes('NUMBER')) {
                                                        formatNumber = true;
                                                    }

                                                    if (textValue !== '%') {
                                                        return <View
                                                            key={`col-${colIndex}`}
                                                            style={{
                                                                flex: (`${box}` !== 'body2w100' && `${box}` !== 'body4w50') ? 1 : null,
                                                                width: (`${box}` === 'body2w100' || `${box}` === 'body4w50') ?
                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'itemPropertyItemProp') ? '20%' :
                                                                        (`${box}` === 'body2w100' && rowItem.idFieldTable === 'bankAccountType') ? '20%' :
                                                                            (`${box}` === 'body2w100' && rowItem.idFieldTable === 'bank') ? '30%' :
                                                                                (`${box}` === 'body2w100' && rowItem.idFieldTable === 'number') ? '15%' :
                                                                                    (`${box}` === 'body2w100' && rowItem.idFieldTable === 'amount') ? '15%' :
                                                                                        (`${box}` === 'body4w50' && rowItem.idFieldTable === 'itemPropertyId') ? '70%' :
                                                                                            (`${box}` === 'body4w50' && rowItem.idFieldTable === 'amountWords') ? '70%' :
                                                                                                (`${box}` === 'body4w50' && rowItem.idFieldTable === 'rate') ? '2%' :
                                                                                                    (`${box}` === 'body4w50' && rowItem.idFieldTable === 'symbol') ? '1%' :
                                                                                                        (`${box}` === 'body4w50' && (rowItem.idFieldTable === 'amount' || rowItem.idFieldTable === 'amountSigned')) ? '29%'
                                                                                                            : '1px'
                                                                    : null,
                                                                borderRight: (`${box}` === 'header4w50' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                                padding: `${box}` !== 'body3w50' ? 4 : 1,
                                                            }}
                                                        >
                                                            <Text
                                                                style={[
                                                                    styles.sectionText,
                                                                    {
                                                                        textAlign:
                                                                            `${box}` === 'header4w50'
                                                                                ? 'center' :
                                                                                `${box}` === 'body4w50' && rowItem.idFieldTable === 'amountWords' ? 'left' :
                                                                                    (`${box}` === 'body4w50' && (rowItem.idFieldTable === 'amount' || rowItem.idFieldTable === 'amountSigned')) ? 'right'
                                                                                        : `${box}` === 'body2w100' && rowItem.idFieldTable === 'amount'
                                                                                            ? 'right'
                                                                                            : `${box}` === 'body1w100' && colIndex > 7
                                                                                                ? 'center'
                                                                                                : `${box}` === 'body3w50' && formatNumber
                                                                                                    ? 'right'
                                                                                                    : 'left',
                                                                    },
                                                                ]}
                                                            >
                                                                {textValue}
                                                            </Text>
                                                        </View>
                                                    }
                                                    return null;
                                                }
                                                return null;
                                            }
                                            return null;
                                        })
                                        }
                                    </View >
                                );
                            }

                            return <View key={`group-${gIndex}`}>{rows}</View>;

                        });
                    }
                }
            });
        })
}

const renderFieldsPrintFunds = (data, box, field, group, currencys) => {
    const dataEstructura = data;

    return dataEstructura.crud.boxes
        .filter((boxItem) => boxItem.box === box)
        .map((boxItem) => {

            let country = "";
            boxItem.fields.forEach((itemFields) => {
                if (box === 'header6w100') {
                    if (itemFields.idFieldTable === 'country') {
                        country = itemFields.name
                            ? itemFields.name + " " + (field[itemFields.id] || "")
                            : field[itemFields.id] || "";
                    }
                }
            });

            let symbolCurrency = "";
            boxItem.fields.forEach((itemFields) => {
                if (itemFields.idFieldTable === 'currencyId') {
                    if (field[itemFields.id]) {
                        for (let d = 0; d < currencys.length; d++) {
                            if (Number(currencys[d].id) === Number(field[itemFields.id])) {
                                symbolCurrency = currencys[d].symbol;
                            }
                        }
                    }
                }
            })

            if (!symbolCurrency) {
                dataEstructura.crud.boxes.forEach((boxItem1) => {
                    boxItem1.fields.forEach((itemFields) => {
                        if (itemFields.idFieldTable === 'currencyId') {
                            if (field[itemFields.id]) {
                                for (let d = 0; d < currencys.length; d++) {
                                    if (Number(currencys[d].id) === Number(field[itemFields.id])) {
                                        symbolCurrency = currencys[d].symbol;
                                    }
                                }
                            }
                        }
                    })
                })
            }

            let line = [];
            return boxItem.fields.map((itemFields, index) => {

                if (itemFields.display === 'hidden') {
                    if (line.length > 0) {
                        return <View key={`line-${index}`}
                            style={{
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                padding: (`${box}` === 'header4w50') ? 8 : (`${box}` === 'footer2w50') ? 14 : 1,
                                borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                            }}
                        >
                            {line}
                        </View>;
                    } else {
                        return null;
                    }
                } else {
                    if (itemFields.group === null) {

                        let view = true;
                        if (itemFields.where !== null && itemFields.where !== undefined)
                            view = whereFunction(itemFields, field);

                        if (view === true) {
                            let textValue = "";
                            let valueField = "";
                            switch (itemFields.type) {
                                case 'Typography':
                                    textValue = itemFields.defaultValue;
                                    valueField = itemFields.defaultValue;
                                    break;
                                case 'Select':
                                    let label = field[itemFields.id] ? field[itemFields.id].label : ""
                                    valueField = label;
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (label || "")
                                        : label || "";
                                    break;
                                case 'Date':
                                    if (field[itemFields.id]) {
                                        let dateSplit = field[itemFields.id].split('-');
                                        let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                        valueField = dateNow;
                                        textValue = dateNow
                                            ? itemFields.name + " " + (dateNow || "")
                                            : dateNow || "";
                                    } else {
                                        textValue = itemFields.name
                                            ? itemFields.name + " " + ("" || "")
                                            : "" || "";
                                    }
                                    break;
                                case 'Currency':
                                    let val = field[itemFields.id] ? `${symbolCurrency} ${field[itemFields.id]}` : ""
                                    valueField = val;
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (val || " ")
                                        : val || " ";
                                    break;
                                default:
                                    valueField = field[itemFields.id];
                                    textValue = itemFields.name
                                        ? itemFields.name + " " + (field[itemFields.id] || "")
                                        : field[itemFields.id] || "";
                                    break;
                            }

                            if (itemFields.type.toUpperCase().includes('PERCENT')) {
                                textValue = textValue + "%";
                            }
                            let comparateIdFieldTable = itemFields.idFieldTable ? itemFields.idFieldTable : "";

                            let logoName = null;
                            if (comparateIdFieldTable.toUpperCase().includes('IMG')) {
                                let splitLogoName = field[itemFields.id].split('/');
                                logoName = splitLogoName[splitLogoName.length - 1];
                            }
                            const element = comparateIdFieldTable.toUpperCase().includes('IMG') ? (
                                <image.renderLogoFunds logoName={logoName !== null ? logoName : 'WINVEST_LOGO_color.png'} />
                            ) : ((box === 'header6w100' && itemFields.idFieldTable !== 'country') || (box === 'body2w100' && itemFields.type !== 'Typography')) ? (
                                // 👉 Modo especial: nombre y valor en dos columnas
                                <View
                                    key={index}
                                    style={{
                                        flexDirection: 'row',
                                        width: (itemFields.idFieldTable === 'signatureUsageId' || itemFields.idFieldTable === 'tradeAccountName') ? "50%" : "100%",

                                    }}
                                >
                                    {/* Columna izquierda: nombre */}
                                    <View
                                        style={{
                                            width: '50%',
                                            borderRight: "1px solid #000", // 🔹 línea vertical divisoria
                                            paddingRight: 4,                 // 🔹 espacio a la derecha
                                        }}
                                    >
                                        <Text
                                            style={[
                                                styles.sectionText,
                                                {
                                                    textAlign: 'right',
                                                },
                                            ]}
                                        >
                                            {itemFields.name || ''}
                                        </Text>
                                    </View>

                                    {/* Columna derecha: valor */}
                                    <View
                                        style={{
                                            width: '50%',
                                            paddingLeft: 4, // 🔹 pequeño espacio a la izquierda del valor
                                            borderRight: itemFields.idFieldTable === 'signatureUsageId' ? "1px solid #000" : null,
                                        }}
                                    >
                                        <Text
                                            style={[
                                                styles.sectionText,
                                                {
                                                    textAlign: box === 'body2w100' ? "right" : "left",
                                                    fontFamily: 'Helvetica-Bold',
                                                },
                                            ]}
                                        >
                                            {valueField} {itemFields.idFieldTable === 'state' ? country : ""}
                                        </Text>
                                    </View>
                                </View>
                            ) : (
                                (box !== 'header6w100' && itemFields.idFieldTable !== 'country') ?
                                    // 👉 Caso normal (sin columnas)
                                    <>
                                        <Text
                                            key={index}
                                            style={[
                                                styles.sectionText,
                                                {
                                                    fontFamily:
                                                        (box === 'header4w50' && itemFields.idFieldTable === 'printName') || box === 'header4w66' || box === 'header5w33'
                                                            ? 'Helvetica-Bold'
                                                            : 'Helvetica',
                                                    fontWeight:
                                                        (box === 'header4w50' && itemFields.idFieldTable === 'printName') || box === 'header4w66' || box === 'header5w33'
                                                            ? 'bold'
                                                            : '',
                                                },
                                            ]}
                                        >
                                            {textValue}
                                        </Text>
                                        <Text key={index} style={styles.sectionText}>
                                            {' '}
                                        </Text>
                                    </> : <></>
                            );
                            // Si columnBreak es true, agregamos la línea actual y empezamos otra
                            if (itemFields.columnBreak) {
                                const currentLine = [...line, element];
                                line = [];
                                return <View key={`line-${index}`}
                                    style={{
                                        flexDirection: 'row', flexWrap: 'wrap',
                                        padding: (`${box}` === 'header6w100' || `${box}` === 'body2w100') ? 0 : 1,
                                        borderBottom: (`${box}` === 'header4w50' || `${box}` === 'header6w100' || `${box}` === 'body2w100') ? "1px solid #000" : "",
                                        justifyContent: (`${box}` === 'header4w50' || `${box}` === 'body2w100' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                    }}>
                                    {currentLine}
                                </View>;
                            } else {
                                line.push(element);
                                // Si es el último campo, devolvemos la línea

                                if (index === boxItem.fields.length - 1) {
                                    return <View key={`line-${index}`}
                                        style={{
                                            flexDirection: 'row',
                                            flexWrap: 'wrap',
                                            padding: (`${box}` === 'header6w100' || `${box}` === 'body2w100') ? 0 : (`${box}` === 'footer2w50') ? 14 : 1,
                                            borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                            justifyContent: (`${box}` === 'header4w50' || `${box}` === 'body2w100' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                        }}
                                    >
                                        {line}
                                    </View>;
                                }
                                return null; // seguimos acumulando
                            }
                        }
                        if (index === boxItem.fields.length - 1) {

                            return <View key={`line-${index}`}
                                style={{
                                    flexDirection: 'row',
                                    flexWrap: 'wrap',
                                    padding: (`${box}` === 'header6w100' || `${box}` === 'body2w100') ? 0 : (`${box}` === 'footer2w50') ? 14 : 1,
                                    borderBottom: (`${box}` === 'header4w50') ? "1px solid #000" : "",
                                    justifyContent: (`${box}` === 'header4w50' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                }}
                            >
                                {line}
                            </View>;
                        }
                        return null;

                    } else {

                        return itemFields.group.map((itemFieldsGroup, gIndex) => {

                            const nameGroup = itemFieldsGroup.name;

                            const items = group[nameGroup] || [];
                            const rows = [];

                            if (line.length > 0) {
                                rows.push(<View key={`line-${index}`}
                                    style={{
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        padding: (`${box}` === 'header4w50') ? 8 : (`${box}` === 'footer2w50') ? 14 : 1,
                                        borderBottom: (`${box}` === 'header7w100') ? "1px solid #000" : "",
                                        justifyContent: (`${box}` === 'header7w100' || `${box}` === 'body2w100' || `${box}` === 'footer2w50') ? 'center' : 'left',

                                    }}
                                >
                                    {line}
                                </View>)
                                line = [];
                            }

                            for (let i = 0; i < items.length; i++) {
                                if (i === 0) {
                                    rows.push(
                                        <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', borderBottom: (`${box}` === 'header7w100' || `${box}` === 'body2w100') ? "1px solid #000" : '' }}>
                                            {items[i].fields.map((rowItem, colIndex) => {
                                                if (rowItem.display !== 'hidden' && rowItem.name) {

                                                    let view = true;
                                                    if (rowItem.where !== null && rowItem.where !== undefined)
                                                        view = whereFunction(rowItem, field);

                                                    if (view === true) {
                                                        return <View key={`col-${colIndex}`}
                                                            style={{
                                                                flex: 1,
                                                                textAlign: `${box}` === 'header7w100' && rowItem.idFieldTable === 'fullName' ? 'left' : "center",
                                                                borderRight: (`${box}` === 'header7w100' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                                padding: 4
                                                            }}

                                                        >
                                                            <Text style={styles.sectionText}>
                                                                {rowItem.name}
                                                            </Text>
                                                        </View>
                                                    }
                                                    return null;
                                                }
                                                return null;
                                            })}
                                        </View>
                                    );
                                }

                                let symbolCurrencyGroup = "";
                                items[i].fields.forEach((itemFields) => {
                                    if (itemFields.idFieldTable === 'currencyId') {
                                        if (field[itemFields.id]) {
                                            for (let d = 0; d < currencys.length; d++) {
                                                if (Number(currencys[d].id) === Number(field[itemFields.id])) {
                                                    symbolCurrencyGroup = currencys[d].symbol;
                                                }
                                            }
                                        }
                                    }
                                })
                                if (!symbolCurrencyGroup)
                                    symbolCurrencyGroup = symbolCurrency;

                                rows.push(
                                    <View key={`${gIndex}-row-${i}`} style={{ flexDirection: 'row', justifyContent: `${box}` === 'header4w50' ? 'center' : 'left' }}>
                                        {items[i].fields.map((rowItem, colIndex) => {
                                            if (rowItem.display !== 'hidden') {
                                                let view = true;
                                                if (rowItem.where !== null && rowItem.where !== undefined)
                                                    view = whereFunction(rowItem, field);

                                                if (view === true) {
                                                    let textValue = "";
                                                    switch (rowItem.type) {
                                                        case 'Typography':
                                                            textValue = rowItem.defaultValue;
                                                            break;
                                                        case 'Select':
                                                            textValue = field[rowItem.id] ? field[rowItem.id].label : "";
                                                            break;
                                                        case 'Date':
                                                            if (field[rowItem.id]) {
                                                                let dateSplit = field[rowItem.id].split('-');
                                                                let dateNow = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0].substring(2, 4)}`
                                                                textValue = dateNow;
                                                            } else {
                                                                textValue = "";
                                                            }
                                                            break;
                                                        case 'Currency':
                                                            let val = field[rowItem.id] ? `${symbolCurrencyGroup} ${field[rowItem.id]}` : ""
                                                            textValue = val;
                                                            break;
                                                        default:
                                                            textValue = field[rowItem.id];
                                                            break;
                                                    }

                                                    if (rowItem.type.toUpperCase().includes('PERCENT')) {
                                                        textValue = textValue + "%";
                                                    }

                                                    let formatNumber = false;
                                                    if (rowItem.type.toUpperCase().includes('PERCEN') || rowItem.type.toUpperCase().includes('CURRENCY') || rowItem.type.toUpperCase().includes('NUMBER')) {
                                                        formatNumber = true;
                                                    }
                                                    if (textValue !== '%') {
                                                        return <View
                                                            key={`col-${colIndex}`}
                                                            style={{
                                                                flex: 1,
                                                                borderBottom: (`${box}` === 'header7w100' && items.length - 1 !== i) ? "1px solid #000" : "",
                                                                borderRight: (`${box}` === 'header7w100' && items[i].fields.length - 1 !== colIndex) ? "1px solid #000" : "",
                                                                padding: `${box}` !== 'body3w50' ? 4 : 1,
                                                            }}
                                                        >
                                                            <Text
                                                                style={[
                                                                    styles.sectionText,
                                                                    {
                                                                        textAlign:
                                                                            `${box}` === 'header4w50'
                                                                                ? 'center' :
                                                                                `${box}` === 'header7w100' && rowItem.idFieldTable === 'argAfipTinType' ? 'center' :
                                                                                    `${box}` === 'header7w100' && rowItem.idFieldTable === 'argTin' ? 'center'
                                                                                        : `${box}` === 'body2w100' && rowItem.idFieldTable === 'amount'
                                                                                            ? 'right'
                                                                                            : `${box}` === 'body1w100' && colIndex > 7
                                                                                                ? 'center'
                                                                                                : `${box}` === 'body3w50' && formatNumber
                                                                                                    ? 'right'
                                                                                                    : 'left',
                                                                    },
                                                                ]}
                                                            >
                                                                {textValue}
                                                            </Text>
                                                        </View>
                                                    }
                                                    return null;
                                                }
                                                return null;
                                            }
                                            return null;
                                        })
                                        }
                                    </View >
                                );
                            }

                            return <View key={`group-${gIndex}`}>{rows}</View>;

                        });
                    }
                }
            });
        })
}

const renderPrint = {
    loadRecordPrint,
    renderFieldsPrintTicket,
    renderFieldsPrintDividens,
    renderFieldsPrintLedger,
    renderFieldsPrintFunds,
    styles
}
export default renderPrint;